/** Stable message identities for operations UI. English aliases preserve legacy callers. */
export const operationMessages: Record<string, string> = {
  "ops.today.1sawk0u": "Today",
  "ops.operations.1ahoaq7": "Operations",
  "ops.shifts.1f7h1j0": "Shifts",
  "ops.assignments.1s400d5": "Assignments",
  "ops.workload.fatsjg": "Workload",
  "ops.bookings.1r3c8qh": "Bookings",
  "ops.units.ur18vw": "Units",
  "ops.calendar.17xfl1b": "Calendar",
  "ops.workforce.8mcvpv": "Workforce",
  "ops.people.10i543y": "People",
  "ops.changes.z69n1m": "Changes",
  "ops.properties.work.rules.1e6yfk0": "Properties & work rules",
  "ops.administration.13wux9r": "Administration",
  "ops.integrations.1sd7qpm": "Integrations",
  "ops.opening.your.operations.workspace.1jk5jv5": "Opening your operations workspace…",
  "ops.retry.zkouah": "Retry",
  "ops.existing.data.is.preserved.legacy.records.1kg60dx": "Existing data is preserved. Legacy records are migrated once into the canonical workspace.",
  "ops.close.navigation.1ynuomf": "Close navigation",
  "ops.operations.workspace.aeoh3y": "Operations workspace",
  "ops.main.navigation.1iucaq2": "Main navigation",
  "ops.active.shifts.3alxqs": "Active shifts",
  "ops.prototype.tools.pth78y": "Prototype tools",
  "ops.admin.dispatcher.shvo3e": "Admin / Dispatcher",
  "ops.local.prototype.1lk61im": "Local prototype",
  "ops.open.navigation.1f2882l": "Open navigation",
  "ops.collapse.navigation.a3qggg": "Collapse navigation",
  "ops.expand.navigation.1tge991": "Expand navigation",
  "ops.breadcrumb.dfc3fw": "Breadcrumb",
  "ops.new.shift.1o7ezlt": "New shift",
  "ops.details.43f6md": "Details",
  "ops.find.a.view.nidyzw": "Find a view…",
  "ops.find.a.view.1oz1x6q": "Find a view",
  "ops.open.changes.1ssgi7o": "Open changes",
  "ops.interface.language.sk0cbe": "Interface language",
  "ops.dismiss.an1pf7": "Dismiss",
  "ops.close.1l0xxoj": "Close",
  "ops.this.prototype.uses.one.canonical.indexeddb.wvbpcm": "This prototype uses one canonical IndexedDB workspace. External synchronization is simulated. Original legacy storage is retained as a migration backup.",
  "ops.schema.16bx8pi": "Schema",
  "ops.revision.1pi2b08": "Revision",
  "ops.audit.events.d3z1c9": "Audit events",
  "ops.export.workspace.backup.1rm3h54": "Export workspace backup",
  "ops.simulation.runs.and.their.outcomes.are.h20rhu": "Simulation runs and their outcomes are available under Integrations. This workspace does not send data to Hotellinx or Quinyx.",
  "ops.see.the.stay.understand.the.turnover.6ps707": "See the stay, understand the turnover. Bookings and actual access remain separate facts.",
  "ops.add.booking.1ud3i27": "Add booking",
  "ops.calendar.range.1agvq8q": "Calendar range",
  "ops.week.nuinp9": "Week",
  "ops.two.weeks.1jjqixk": "Two weeks",
  "ops.four.weeks.p04pyk": "Four weeks",
  "ops.search.units.guests.or.booking.references.1o3y81f": "Search units, guests or booking references",
  "ops.search.bookings.8r9ovf": "Search bookings",
  "ops.booking.segments.in.this.period.1uvufgk": "booking segments in this period",
  "ops.continuous.stay.internal.boundaries.need.no.8rroqz": "Continuous stay: internal boundaries need no turnover clean",
  "ops.selected.lnii5w": "selected",
  "ops.clear.1aeugy": "Clear",
  "ops.review.continuity.k5ylnh": "Review continuity",
  "ops.select.booking.48c472": "Select booking",
  "ops.continuous.stay.m6irvf": "Continuous stay",
  "ops.no.bookings.in.this.period.taoy4g": "No bookings in this period",
  "ops.choose.another.period.or.add.a.1svp6tr": "Choose another period or add a booking. Empty booking data is not proof of vacancy.",
  "ops.property.unit.17mli3x": "Property / unit",
  "ops.no.matching.units.uorpb2": "No matching units",
  "ops.clear.the.filters.to.show.the.xxnaxk": "Clear the filters to show the booking calendar.",
  "ops.no.cleaning.between.linked.segments.1a9j0qg": "No cleaning between linked segments",
  "ops.original.booking.boundary.no.turnover.cleaning.p6uzol": "Original booking boundary; no turnover cleaning",
  "ops.booking.details.69yq1y": "Booking details",
  "ops.cancel.ew9em3": "Cancel",
  "ops.save.booking.17mozeb": "Save booking",
  "ops.done.13cn9g1": "Done",
  "ops.edit.booking.1ev4wr6": "Edit booking",
  "ops.unit.t3mdrb": "Unit",
  "ops.guest.or.booking.name.japayi": "Guest or booking name",
  "ops.guest.stay.identity.reference.16fhfvm": "Guest / stay identity reference",
  "ops.a.name.alone.is.not.a.1bbj7h6": "A name alone is not a verified guest identity.",
  "ops.arrival.152t02": "Arrival",
  "ops.departure.nj6qdr": "Departure",
  "ops.booking.corrections.are.applied.truthfully.any.13m3rgm": "Booking corrections are applied truthfully. Any linked continuous stay is revalidated, and affected commitments receive a review proposal.",
  "ops.local.override.u9zh1k": "Local override",
  "ops.source.r5qyuw": "Source",
  "ops.guest.identity.1nrivo7": "Guest identity",
  "ops.not.verified.jupd72": "Not verified",
  "ops.source.revision.vq0tvh": "Source revision",
  "ops.verified.continuous.stay.191j44t": "Verified continuous stay",
  "ops.continuity.needs.review.11ki75a": "Continuity needs review",
  "ops.review.unlinking.qtz178": "Review unlinking",
  "ops.related.work.15000d1": "Related work",
  "ops.cancel.booking.ygvz8k": "Cancel booking",
  "ops.cancel.this.source.segment.future.workload.1rnahw3": "Cancel this source segment? Future workload is recalculated and committed shifts receive proposals. Actual work stays in history.",
  "ops.confirm.cancellation.153wf06": "Confirm cancellation",
  "ops.keep.booking.dhjxv": "Keep booking",
  "ops.dispatcher.1s6s7pk": "Dispatcher",
  "ops.the.source.changed.refresh.the.preview.1cwp5cq": "The source changed. Refresh the preview before applying.",
  "ops.link.a.continuous.stay.1vzy0zq": "Link a continuous stay",
  "ops.unlink.continuous.stay.tom3ne": "Unlink continuous stay",
  "ops.original.booking.segments.and.actual.work.phjq8q": "Original booking segments and actual work remain intact.",
  "ops.preview.impact.1a28w1z": "Preview impact",
  "ops.apply.reviewed.change.xgbty4": "Apply reviewed change",
  "ops.no.verified.guest.reference.1aibudb": "No verified guest reference",
  "ops.i.confirm.these.bookings.represent.the.1qe6haq": "I confirm these bookings represent the same continuous stay in this unit. Matching names alone are not sufficient.",
  "ops.confirmation.change.reason.145q429": "Confirmation / change reason",
  "ops.workload.impact.1pann6u": "Workload impact",
  "ops.existing.assignments.affected.5xkubq": "existing assignments affected",
  "ops.new.assignments.esnouj": "new assignments",
  "ops.plan.changes.to.review.7ywhj0": "plan changes to review",
  "ops.preview.is.stale.refresh.before.applying.a6nfoe": "Preview is stale. Refresh before applying.",
  "ops.update.the.work.window.6a2z6c": "Update the work window",
  "ops.release.obsolete.unstarted.work.dubwuu": "Release obsolete unstarted work",
  "ops.review.staffing.and.coverage.1yqsuyu": "Review staffing and coverage",
  "ops.plan.new.required.work.n59wkm": "Plan new required work",
  "ops.review.the.current.facts.1kbr968": "Review the current facts",
  "ops.information.1ye3sd1": "Information",
  "ops.needs.attention.pwuroc": "Needs attention",
  "ops.blocking.conflict.1cjn7oo": "Blocking conflict",
  "ops.work.date.2oouus": "Work date",
  "ops.earliest.start.1af7t9s": "Earliest start",
  "ops.ready.by.1lqutzt": "Ready by",
  "ops.estimated.minutes.1ha5dcw": "Estimated minutes",
  "ops.access.ow1nnv": "Access",
  "ops.cleaning.readiness.bjzqw3": "Cleaning / readiness",
  "ops.starts.fc4c10": "Starts",
  "ops.ends.1yii6kb": "Ends",
  "ops.person.1i84mn4": "Person",
  "ops.status.3pd73": "Status",
  "ops.required.skills.17pftey": "Required skills",
  "ops.required.crew.1oqwh81": "Required crew",
  "ops.observed.change.zqrouv": "Observed change",
  "ops.skills.1bk7xrz": "Skills",
  "ops.name.4el6o6": "Name",
  "ops.refresh.this.review.because.the.source.1jr2ja6": "Refresh this review because the source or workspace changed.",
  "ops.explain.why.the.existing.commitment.is.1w2lmvk": "Explain why the existing commitment is being kept.",
  "ops.could.not.save.this.review.decision.cezu34": "Could not save this review decision.",
  "ops.select.pending.changes.before.applying.them.ucaltq": "Select pending changes before applying them.",
  "ops.the.selected.changes.were.updated.refresh.12jm21m": "The selected changes were updated. Refresh the batch review.",
  "ops.could.not.apply.these.changes.together.lnt75t": "Could not apply these changes together.",
  "ops.changes.to.review.tjtrnp": "Changes to review",
  "ops.current.facts.are.live.review.how.7rvjx8": "Current facts are live. Review how your commitments should respond.",
  "ops.changes.in.this.view.1no7i7g": "changes in this view",
  "ops.change.status.dgtf8x": "Change status",
  "ops.pending.review.wk8f6w": "Pending review",
  "ops.review.history.1evfk99": "Review history",
  "ops.all.changes.ins8gt": "All changes",
  "ops.change.urgency.1f3lwyq": "Change urgency",
  "ops.all.urgency.levels.1smxe4i": "All urgency levels",
  "ops.blocking.conflicts.k5bem9": "Blocking conflicts",
  "ops.clear.date.shift.filter.hixxib": "Clear date / shift filter",
  "ops.current.conflicts.1qpruw5": "current conflicts",
  "ops.reviewing.or.keeping.a.commitment.does.17kr7m0": "Reviewing or keeping a commitment does not clear an unresolved operational conflict.",
  "ops.resolve.1qqbo5f": "Resolve",
  "ops.more.current.conflicts.db7ap6": "more current conflicts",
  "ops.pending.changes.selected.11x5m8u": "pending changes selected",
  "ops.clear.selection.mdlo0w": "Clear selection",
  "ops.review.selected.1ilyn8i": "Review selected",
  "ops.property.msefhk": "Property",
  "ops.new.demand.outside.a.shift.14nawl4": "New demand outside a shift",
  "ops.open.shift.atb37d": "Open shift",
  "ops.open.workload.xri4g6": "Open workload",
  "ops.select.change.1rqc4dv": "Select change",
  "ops.review.change.99uz9z": "Review change",
  "ops.no.changes.in.this.view.91fpar": "No changes in this view",
  "ops.relevant.source.changes.and.new.required.1m1dl7c": "Relevant source changes and new required work appear here. Existing conflicts remain visible until resolved.",
  "ops.change.decisions.will.appear.here.after.b5b7dg": "Change decisions will appear here after dispatcher review.",
  "ops.review.impact.1f81015": "Review impact",
  "ops.keep.commitment.1pjyr4t": "Keep commitment",
  "ops.apply.proposal.lhbz6r": "Apply proposal",
  "ops.review.selected.changes.qzpctv": "Review selected changes",
  "ops.these.decisions.are.committed.together.existing.1ltt41m": "These decisions are committed together. Existing actual work and unrelated commitments are preserved.",
  "ops.apply.selected.proposals.ob3qzj": "Apply selected proposals",
  "ops.before.afxo4e": "Before",
  "ops.current.proposed.mvyc8n": "Current / proposed",
  "ops.the.workspace.changed.while.this.review.yyufiy": "The workspace changed while this review was open. Refresh the selected changes before applying.",
  "ops.refresh.review.jy4m8w": "Refresh review",
  "ops.unplanned.workload.1rvyxhx": "Unplanned workload",
  "ops.received.psn4r6": "Received",
  "ops.a.newer.source.change.supersedes.this.2pnfet": "A newer source change supersedes this proposal.",
  "ops.the.workspace.changed.while.this.review.6mrxob": "The workspace changed while this review was open.",
  "ops.your.inputs.are.preserved.refresh.the.sc3txc": "Your inputs are preserved. Refresh the current facts before making a decision.",
  "ops.field.4d0paf": "Field",
  "ops.previous.commitment.17ibfwd": "Previous commitment",
  "ops.current.fact.requirement.1f7o2uu": "Current fact / requirement",
  "ops.proposed.action.f9kp17": "Proposed action",
  "ops.release.only.unstarted.obsolete.work.from.5m7qn0": "Release only unstarted obsolete work from this shift. Completed work, actual sessions, and linen operations remain.",
  "ops.use.the.latest.required.window.while.lgp5wa": "Use the latest required window while preserving the assignment identity and actual work. Scheduling conflicts remain visible until the plan fits.",
  "ops.keep.this.new.obligation.visible.in.1p9fjqk": "Keep this new obligation visible in the workload pool. Reviewing it does not silently add it to a shift.",
  "ops.review.the.affected.person.and.coverage.14cdhey": "Review the affected person and coverage. Work stays visible for reassignment; actual participation is retained.",
  "ops.acknowledge.the.changed.requirement.current.access.1jt80rz": "Acknowledge the changed requirement. Current access, availability, and other operational facts remain live.",
  "ops.open.assignment.q5eg1u": "Open assignment",
  "ops.current.unit.facts.1awkq9b": "Current unit facts",
  "ops.current.record.63jt2z": "Current record",
  "ops.still.needs.a.decision.3ig9sb": "Still needs a decision",
  "ops.keeping.a.commitment.does.not.override.3nht9t": "Keeping a commitment does not override a mandatory execution requirement.",
  "ops.reason.for.keeping.the.commitment.required.4exbsh": "Reason for keeping the commitment (required for Keep)",
  "ops.explain.the.operational.decision.current.facts.1qmrdsm": "Explain the operational decision; current facts will not be replaced.",
  "ops.recorded.decision.46thil": "Recorded decision",
  "ops.the.work.people.and.decisions.that.1dx2uk5": "The work, people, and decisions that shape your day.",
  "ops.plan.a.shift.1oqualh": "Plan a shift",
  "ops.work.to.plan.1o0m890": "Work to plan",
  "ops.in.undated.backlog.2j3cp8": "in undated backlog",
  "ops.unfilled.positions.1j7na3e": "Unfilled positions",
  "ops.estimated.capacity.gap.1ov1d53": "estimated capacity gap",
  "ops.across.planned.and.active.shifts.15exnpo": "Across planned and active shifts",
  "ops.blocking.changes.ewhhaf": "blocking changes",
  "ops.shifts.in.operation.ewgk9e": "Shifts in operation",
  "ops.active.1oc52r3": "active",
  "ops.planned.k7wvxh": "planned",
  "ops.shifts.for.this.day.s0ho9n": "Shifts for this day",
  "ops.view.all.kmabij": "View all",
  "ops.changes.geyte2": "changes",
  "ops.conflicts.1tyqwvo": "conflicts",
  "ops.unfilled.11ovxdy": "unfilled",
  "ops.no.shifts.for.this.day.a6x1ja": "No shifts for this day",
  "ops.review.available.work.and.workforce.then.8nrwan": "Review available work and workforce, then bring them together in a shift.",
  "ops.review.workload.qpxbqm": "Review workload",
  "ops.decisions.first.1rtpcu6": "Decisions first",
  "ops.no.new.changes.need.review.for.1yr1wza": "No new changes need review for this day.",
  "ops.booking.boundaries.6fu4ou": "Booking boundaries",
  "ops.arrivals.16tci5v": "Arrivals",
  "ops.departures.1wkl0": "Departures",
  "ops.planned.booking.boundaries.do.not.confirm.uo1dz1": "Planned booking boundaries do not confirm vacancy or cleaning readiness.",
  "ops.open.booking.calendar.1ec89c": "Open booking calendar",
  "ops.could.not.simulate.synchronization.vsbxx3": "Could not simulate synchronization.",
  "ops.manage.source.identity.ownership.synchronization.policy.gughen": "Manage source identity, ownership, synchronization policy, and run history separately from operational rules.",
  "ops.this.prototype.uses.local.files.and.1pn7qt8": "This prototype uses local files and simulated outbound runs. No external system is contacted.",
  "ops.bookings.and.source.observations.with.guarded.k1wlvq": "Bookings and source observations, with guarded cleaning-status synchronization.",
  "ops.simulation.enabled.1dwwqq7": "Simulation enabled",
  "ops.paused.1pn27zf": "Paused",
  "ops.verified.employee.identities.and.daily.working.1mkmj7s": "Verified employee identities and daily working intervals from XLSX exports.",
  "ops.file.import.btf59c": "File import",
  "ops.administration.integrations.1ijkjvp": "Administration / Integrations",
  "ops.source.identity.and.synchronization.policy.for.qwcsrp": "Source identity and synchronization policy for the relevant stay and service cycle.",
  "ops.local.schedule.imports.with.explicit.employee.1ejo0eo": "Local schedule imports with explicit employee matching and reviewed interval changes.",
  "ops.all.integrations.1kw1f53": "All integrations",
  "ops.simulating.710ka": "Simulating…",
  "ops.simulate.sync.run.rbo01b": "Simulate sync run",
  "ops.import.quinyx.8nsmzc": "Import Quinyx",
  "ops.connector.views.11a3dee": "Connector views",
  "ops.inbound.ownership.19etfhz": "Inbound ownership",
  "ops.outbound.rules.1otl0lq": "Outbound rules",
  "ops.local.simulation.adapter.nv8tro": "Local simulation adapter",
  "ops.local.file.adapter.cgw21l": "Local file adapter",
  "ops.inbound.bookings.can.be.reviewed.in.b1wne7": "Inbound bookings can be reviewed in the Booking calendar. Outbound intents are evaluated and simulated locally; no credentials, network connection, or real send is configured.",
  "ops.the.supported.daily.xlsx.profile.reads.oat3lo": "The supported daily XLSX profile reads only verified dates and working intervals. Unsupported layouts fail explicitly and cannot change existing availability.",
  "ops.no.real.outbound.connection.1881nue": "No real outbound connection",
  "ops.mapped.identities.1u4bg74": "Mapped identities",
  "ops.recorded.run.items.qi5lys": "Recorded run items",
  "ops.items.needing.attention.1joxyit": "Items needing attention",
  "ops.review.operational.impacts.1on2ryy": "Review operational impacts",
  "ops.unit.identity.mapping.iwbgjl": "Unit identity mapping",
  "ops.employee.identity.mapping.gka8x7": "Employee identity mapping",
  "ops.external.ids.link.to.stable.luuta.jedbrf": "External IDs link to stable Luuta identities. Display names are never used as automatic identifiers.",
  "ops.not.mapped.r1osyh": "Not mapped",
  "ops.map.identity.19kvlcd": "Map identity",
  "ops.edit.mapping.k1m607": "Edit mapping",
  "ops.fact.ownership.1xz0y7q": "Fact ownership",
  "ops.imported.observations.and.luuta.operational.facts.ld4x48": "Imported observations and Luuta operational facts are distinct. A newer upload does not automatically override a confirmed local fact.",
  "ops.booking.dates.and.source.guest.reference.uf414w": "Booking dates and source guest reference",
  "ops.source.revisions.update.booking.facts.immediately.1bxvr07": "Source revisions update booking facts immediately; affected commitments receive review.",
  "ops.actual.access.and.checkout.confirmation.1mtmu93": "Actual access and checkout confirmation",
  "ops.scheduled.checkout.is.not.proof.of.1nvbalh": "Scheduled checkout is not proof of vacancy. Operational confirmation remains a separate fact.",
  "ops.cleaning.quality.inspection.and.guest.readiness.1813bng": "Cleaning, quality inspection, and guest readiness",
  "ops.service.completion.and.inspection.remain.independently.1gadj9e": "Service completion and inspection remain independently recorded.",
  "ops.comment.derived.flags.1llmba1": "Comment-derived flags",
  "ops.review.tnr3lt": "Review",
  "ops.suggestions.require.review.and.retain.their.1512pfi": "Suggestions require review and retain their source and relevant stay context.",
  "ops.employee.external.identifier.1y1omsj": "Employee external identifier",
  "ops.mapped.identity.1b0b9o4": "Mapped identity",
  "ops.ambiguous.identity.requires.explicit.resolution.matching.y8ynp4": "Ambiguous identity requires explicit resolution. Matching names alone never merge people.",
  "ops.source.schedule.intervals.x2or3b": "Source schedule intervals",
  "ops.only.declared.complete.source.coverage.permits.hkdznb": "Only declared complete source coverage permits missing-row removals.",
  "ops.manual.hours.and.selected.field.overrides.1x8sxlj": "Manual hours and selected field overrides",
  "ops.reviewed.override.1kkglh4": "Reviewed override",
  "ops.the.import.compares.source.base.local.12aqv0k": "The import compares source/base/local values and offers Use source for each changed field.",
  "ops.actual.attendance.kzefwy": "Actual attendance",
  "ops.importing.planned.hours.does.not.assert.15iro4p": "Importing planned hours does not assert presence or assign a shift.",
  "ops.these.adapter.contracts.define.the.current.1xf14lw": "These adapter contracts define the current prototype. Production connector permissions and supported write fields must be verified before connecting an external system.",
  "ops.cleaning.status.write.back.1ox0lq4": "Cleaning-status write-back",
  "ops.evaluate.the.relevant.completed.service.and.4rsrzk": "Evaluate the relevant completed service and stay cycle against current occupancy before every attempted update.",
  "ops.edit.sync.policy.m166ba": "Edit sync policy",
  "ops.only.after.confirmed.checkout.1e5infc": "Only after confirmed checkout",
  "ops.when.current.cycle.is.eligible.1j8s4zv": "When current cycle is eligible",
  "ops.never.synchronize.inrl7v": "Never synchronize",
  "ops.a.new.stay.invalidates.an.old.ibgpv8": "A new stay invalidates an old cleaning update. Cleaned and guest-ready are distinct Luuta facts; only the configured service result is considered.",
  "ops.current.eligibility.preview.xr55sj": "Current eligibility preview",
  "ops.no.completed.service.updates.11low0u": "No completed service updates",
  "ops.completed.service.results.appear.here.with.1jwlk7c": "Completed service results appear here with their current stay-cycle eligibility.",
  "ops.quinyx.write.back.is.not.connected.9ll6q8": "Quinyx write-back is not connected",
  "ops.this.prototype.imports.schedule.files.it.7wf85j": "This prototype imports schedule files. It never sends modified workdays, attendance, or shifts to Quinyx. Bidirectional synchronization requires a separately verified production adapter and agreed ownership rules.",
  "ops.run.history.ltyvna": "Run history",
  "ops.each.result.retains.its.scope.source.iwdeni": "Each result retains its scope, source revision, decision, and outcome.",
  "ops.local.records.only.12g81eg": "Local records only",
  "ops.complete.snapshot.jmdx6": "Complete snapshot",
  "ops.merge.12ow72f": "Merge",
  "ops.preserved.1vnoqif": "preserved",
  "ops.no.runs.recorded.1ju2ek8": "No runs recorded",
  "ops.run.a.local.simulation.to.inspect.ppt4kx": "Run a local simulation to inspect eligibility, held items, and stale changes.",
  "ops.a.reviewed.import.creates.a.run.1sts8wj": "A reviewed import creates a run report with exact calendar changes.",
  "ops.map.external.unit.identity.b19w80": "Map external unit identity",
  "ops.could.not.save.this.mapping.oxtpj8": "Could not save this mapping.",
  "ops.save.mapping.yk95pi": "Save mapping",
  "ops.hotellinx.unit.id.any6lr": "Hotellinx unit ID",
  "ops.use.a.stable.external.identifier.changing.1ovb0tr": "Use a stable external identifier. Changing a mapping does not create a new Luuta unit or rewrite its execution history.",
  "ops.need.attention.11rv5ob": "need attention",
  "ops.last.successful.local.run.hm4r7b": "Last successful local run",
  "ops.not.yet.run.ri555d": "Not yet run",
  "ops.hotellinx.synchronization.policy.vkno1a": "Hotellinx synchronization policy",
  "ops.preview.which.current.service.results.become.duq9va": "Preview which current service results become eligible or held before changing this policy.",
  "ops.could.not.save.this.policy.1dow7sg": "Could not save this policy.",
  "ops.save.reviewed.policy.1hcoyax": "Save reviewed policy",
  "ops.review.policy.4wget": "Review policy",
  "ops.enable.local.synchronization.simulation.uyx33k": "Enable local synchronization simulation",
  "ops.cleaning.status.condition.16okx7y": "Cleaning-status condition",
  "ops.current.cycle.service.results.1kpttco": "Current-cycle service results",
  "ops.every.policy.still.rejects.stale.results.1tx3fjg": "Every policy still rejects stale results from an earlier stay. This does not change any unit’s work rules or send a real update.",
  "ops.policy.impact.preview.12x3tmn": "Policy impact preview",
  "ops.run.details.bo2kas": "Run details",
  "ops.hotellinx.local.simulation.gqih8a": "Hotellinx local simulation",
  "ops.created.2qkacb": "Created",
  "ops.attempted.3zkonj": "Attempted",
  "ops.booking.identity.88fymq": "Booking identity",
  "ops.no.external.system.was.contacted.retry.fgw90": "No external system was contacted. Retry evaluates current facts rather than replaying an outdated update.",
  "ops.period.11hwh7o": "Period",
  "ops.mode.n44ilu": "Mode",
  "ops.applied.gpyu7e": "Applied",
  "ops.file.identity.1ipfjqf": "File identity",
  "ops.run.identity.qdygos": "Run identity",
  "ops.sunday.1lz181l": "Sunday",
  "ops.monday.g6qiqh": "Monday",
  "ops.tuesday.1yi3yk0": "Tuesday",
  "ops.wednesday.1sertdj": "Wednesday",
  "ops.thursday.16pges7": "Thursday",
  "ops.friday.1g69g0i": "Friday",
  "ops.saturday.3zxf06": "Saturday",
  "ops.days.of.the.week.11oz68w": "Days of the week",
  "ops.only.the.selected.days.apply.opa2ge": "Only the selected days apply.",
  "ops.no.selection.means.every.day.1fizdsr": "No selection means every day.",
  "ops.january.17lzfr1": "January",
  "ops.february.1y3owmr": "February",
  "ops.march.1hf0040": "March",
  "ops.april.16euumv": "April",
  "ops.may.gjvv3a": "May",
  "ops.june.1sonp8l": "June",
  "ops.july.b3swv": "July",
  "ops.august.q1ie1o": "August",
  "ops.september.1hujif4": "September",
  "ops.october.1tqs8hz": "October",
  "ops.november.hdqwxr": "November",
  "ops.december.scmx0e": "December",
  "ops.months.season.536cng": "Months / season",
  "ops.apply.only.during.the.selected.months.17kb4wf": "Apply only during the selected months.",
  "ops.no.selection.means.all.months.nvw2ie": "No selection means all months.",
  "ops.type.a.value.and.press.enter.1lqx3fb": "Type a value and press Enter",
  "ops.remove.9c35st": "Remove",
  "ops.none.specified.m1e7l1": "None specified",
  "ops.add.17rv3f8": "Add",
  "ops.work.rules.kr0ttj": "Work rules",
  "ops.property.rules.are.inherited.by.units.1wa8ugs": "Property rules are inherited by units. Preview every change before it creates work.",
  "ops.create.rule.1jo8kk9": "Create rule",
  "ops.active.rules.12yzx88": "Active rules",
  "ops.draft.changes.1ng564l": "Draft changes",
  "ops.unit.exceptions.1y5om73": "Unit exceptions",
  "ops.six.week.preview.by.default.12nkaua": "Six-week preview by default",
  "ops.search.work.rules.1toenk5": "Search work rules",
  "ops.search.rule.service.or.scope.1rhbfyh": "Search rule, service, or scope",
  "ops.rule.status.1wpaz2j": "Rule status",
  "ops.retired.j9u73q": "Retired",
  "ops.all.published.rules.1kxyf6l": "All published rules",
  "ops.rule.scope.s2w2yf": "Rule scope",
  "ops.all.scopes.duno1t": "All scopes",
  "ops.property.rules.1vhw973": "Property rules",
  "ops.unit.rules.5qj5sw": "Unit rules",
  "ops.rule.service.7frh1p": "Rule / service",
  "ops.scope.inheritance.1cj2ett": "Scope & inheritance",
  "ops.effective.period.1p0dci7": "Effective period",
  "ops.actions.1rx51qc": "Actions",
  "ops.draft.changes.available.14z4fji": "Draft changes available",
  "ops.units.in.scope.14g5z3z": "units in scope",
  "ops.disabled.here.1daww55": "disabled here",
  "ops.no.end.date.uh2z1": "No end date",
  "ops.continue.1bipuuc": "Continue",
  "ops.edit.1i1lcq9": "Edit",
  "ops.no.rules.match.these.filters.w65umg": "No rules match these filters",
  "ops.create.your.first.work.rule.18k5hkn": "Create your first work rule",
  "ops.choose.another.status.or.scope.or.qq40tt": "Choose another status or scope, or clear the search.",
  "ops.start.with.a.booking.or.frequency.fjtdoy": "Start with a booking or frequency recipe, then preview the work it will create.",
  "ops.inherited.never.copied.8n03ib": "Inherited, never copied",
  "ops.change.a.property.rule.once.units.1acdct0": "Change a property rule once. Units keep explicit local exceptions and additional rules.",
  "ops.events.and.frequency.m1pxkf": "Events and frequency",
  "ops.combine.booking.events.fixed.schedules.stay.nobejr": "Combine booking events, fixed schedules, stay frequency, and actual service completion.",
  "ops.work.stays.explainable.1dx3dvl": "Work stays explainable",
  "ops.every.assignment.retains.the.rules.and.rkko6l": "Every assignment retains the rules and occurrences it fulfills. Compatible work can be shared.",
  "ops.after.checkout.jev16f": "After checkout",
  "ops.before.check.in.1nwpuvy": "Before check-in",
  "ops.repeat.on.a.calendar.b0r5wq": "Repeat on a calendar",
  "ops.repeat.during.a.stay.vav8z1": "Repeat during a stay",
  "ops.after.the.last.completed.service.iw2kj0": "After the last completed service",
  "ops.when.another.service.is.completed.3mk07y": "When another service is completed",
  "ops.work.1oz7yps": "Work",
  "ops.when.l5nax": "When",
  "ops.applies.to.1ohnv0g": "Applies to",
  "ops.allowed.window.184oz8p": "Allowed window",
  "ops.preview.1yfnwtz": "Preview",
  "ops.select.a.service.1ym6xj1": "Select a service",
  "ops.every.1oueaas": "Every",
  "ops.nights.1072qfq": "nights",
  "ops.create.16gte2l": "Create",
  "ops.for.1bzk7tc": "for",
  "ops.choose.a.scope.qn65x3": "Choose a scope",
  "ops.seasonal.155j4ph": "Seasonal",
  "ops.a.separate.visit.is.required.1rk19sv": "A separate visit is required.",
  "ops.compatible.requirements.may.share.this.work.1qgh9bs": "Compatible requirements may share this work.",
  "ops.give.this.rule.a.name.1newcj6": "Give this rule a name.",
  "ops.choose.a.service.and.the.property.ijfsmx": "Choose a service and the property or unit this rule applies to.",
  "ops.choose.a.valid.effective.date.range.bi04t1": "Choose a valid effective date range.",
  "ops.frequency.must.be.at.least.one.1taoqbl": "Frequency must be at least one.",
  "ops.the.deadline.must.be.after.the.nx1bxu": "The deadline must be after the earliest start.",
  "ops.choose.the.first.due.anchor.because.1nkpm1k": "Choose the first-due anchor because no qualifying completion is available.",
  "ops.the.rule.preview.could.not.be.1lbaeoo": "The rule preview could not be generated.",
  "ops.rule.draft.saved.existing.work.has.1lj9yaa": "Rule draft saved. Existing work has not changed.",
  "ops.could.not.save.the.rule.draft.bvjay6": "Could not save the rule draft.",
  "ops.refresh.the.impact.preview.before.activating.wndroa": "Refresh the impact preview before activating this change.",
  "ops.could.not.activate.this.rule.1quu3qs": "Could not activate this rule.",
  "ops.edit.work.rule.ke99zg": "Edit work rule",
  "ops.create.work.rule.v2fljk": "Create work rule",
  "ops.define.when.work.is.needed.then.1kft18t": "Define when work is needed, then preview its effect before activation.",
  "ops.property.rule.1i6b6jq": "Property rule",
  "ops.unit.rule.1dasbv7": "Unit rule",
  "ops.rule.name.1cx90xu": "Rule name",
  "ops.e.g.summer.departure.cleaning.64mvjn": "e.g. Summer departure cleaning",
  "ops.in.plain.language.1jl940o": "In plain language",
  "ops.service.1eklb0k": "Service",
  "ops.edit.service.ciifpi": "Edit service",
  "ops.new.service.13b76di": "New service",
  "ops.create.service.a3qp56": "Create service",
  "ops.completion.and.assignment.are.independent.for.gq79d4": "Completion and assignment are independent for each service.",
  "ops.access.requirement.16ousno": "Access requirement",
  "ops.confirmed.vacancy.1oe3na3": "Confirmed vacancy",
  "ops.recorded.access.permission.1v2op5c": "Recorded access permission",
  "ops.no.entry.restriction.2anx4k": "No entry restriction",
  "ops.priority.1ryxjjd": "Priority",
  "ops.normal.onobjm": "Normal",
  "ops.high.1gq8xlp": "High",
  "ops.require.a.separate.visit.1t6vcb7": "Require a separate visit",
  "ops.otherwise.one.compatible.assignment.may.fulfill.1tz2uyg": "Otherwise one compatible assignment may fulfill several rules. Every originating requirement remains visible.",
  "ops.start.with.a.recipe.1kyc60g": "Start with a recipe",
  "ops.repeat.every.12bic5p": "Repeat every",
  "ops.frequency.unit.1a6mueh": "Frequency unit",
  "ops.nights.1jn3vqu": "Nights",
  "ops.days.pxfr8q": "Days",
  "ops.weeks.pch9u2": "Weeks",
  "ops.months.2777qa": "Months",
  "ops.calendar.weekdays.17eec6y": "Calendar weekdays",
  "ops.day.of.month.1h7lydk": "Day of month",
  "ops.when.that.day.does.not.exist.mdgnkn": "When that day does not exist",
  "ops.use.the.last.valid.day.tfzbrp": "Use the last valid day",
  "ops.skip.that.occurrence.16ycbxs": "Skip that occurrence",
  "ops.initial.frequency.anchor.p069va": "Initial frequency anchor",
  "ops.calendar.anchor.1jirj8s": "Calendar anchor",
  "ops.without.completion.history.the.interval.starts.1yeay7a": "Without completion history, the interval starts at this date. Actual qualifying completion then advances the next due date; overdue work remains one requirement.",
  "ops.the.anchor.fixes.the.cadence.a.a773e4": "The anchor fixes the cadence; a late completion does not move future calendar occurrences.",
  "ops.qualifying.service.saz8f7": "Qualifying service",
  "ops.trigger.offset.oifmhy": "Trigger offset",
  "ops.negative.values.mean.before.the.event.ydfdbs": "Negative values mean before the event; positive values mean after.",
  "ops.offset.unit.lr4wvc": "Offset unit",
  "ops.calendar.days.ydg7xe": "Calendar days",
  "ops.elapsed.hours.7ufpyg": "Elapsed hours",
  "ops.booking.times.create.a.planning.window.in90u6": "Booking times create a planning window. A scheduled checkout never confirms that a unit is vacant.",
  "ops.scheduling.timezone.an0lne": "Scheduling timezone",
  "ops.property.inherited.by.units.zfgylf": "Property · inherited by units",
  "ops.one.unit.additional.local.rule.zcl4zi": "One unit · additional local rule",
  "ops.units.inherit.property.rules.without.copying.1upm3hy": "Units inherit property rules without copying them. Local rules add work; disabling an inherited rule survives later property edits.",
  "ops.effective.from.1y9m5iq": "Effective from",
  "ops.effective.until.optional.gkiyzp": "Effective until (optional)",
  "ops.event.applicability.p5azye": "Event applicability",
  "ops.these.conditions.choose.which.events.create.v832ni": "These conditions choose which events create work. Allowed working days are configured separately in the next section.",
  "ops.combine.conditions.17mx7u0": "Combine conditions",
  "ops.all.specified.conditions.fls8z8": "All specified conditions",
  "ops.any.specified.condition.16vpt1e": "Any specified condition",
  "ops.event.occurs.on.1p4nap5": "Event occurs on",
  "ops.unit.tags.1bqpxpc": "Unit tags",
  "ops.unit.types.xwu0uy": "Unit types",
  "ops.minimum.stay.length.nights.optional.1oyqsa": "Minimum stay length (nights, optional)",
  "ops.a.service.window.not.a.promise.hz99cw": "A service window, not a promise of vacancy",
  "ops.use.the.departure.and.next.arrival.kajf3j": "Use the departure and next arrival to constrain turnover work. Required access is checked again when someone starts the assignment.",
  "ops.earliest.start.offset.hours.1ip74o9": "Earliest start offset (hours)",
  "ops.relative.to.the.trigger.negative.means.10poq2c": "Relative to the trigger. Negative means before it.",
  "ops.ready.by.offset.hours.78450n": "Ready-by offset (hours)",
  "ops.the.next.arrival.may.make.this.1gvtmjx": "The next arrival may make this deadline earlier.",
  "ops.working.window.starts.1mzdg7d": "Working window starts",
  "ops.working.window.ends.1pr8ara": "Working window ends",
  "ops.work.may.be.scheduled.on.etdplm": "Work may be scheduled on",
  "ops.if.no.permitted.working.day.fits.vnon1": "If no permitted working day fits before the deadline, Luuta creates a Needs scheduling requirement. Required work is never silently skipped.",
  "ops.preview.starts.1khqml0": "Preview starts",
  "ops.projection.jhtig0": "Projection",
  "ops.weeks.1ee510q": "weeks",
  "ops.refresh.preview.1mbfspk": "Refresh preview",
  "ops.generate.preview.b7bwoa": "Generate preview",
  "ops.retirement.preview.future.generation.stops.from.1fpzdh8": "Retirement preview: future generation stops from the effective date. Existing actual work remains intact; allocated changes require review.",
  "ops.source.data.changed.since.this.preview.b120r1": "Source data changed since this preview. Refresh it before activation.",
  "ops.see.the.effect.before.activating.6c2e1z": "See the effect before activating",
  "ops.compare.generated.work.with.the.current.1cl61l5": "Compare generated work with the current plan, including unit exceptions, missing information, and shifts that will need review.",
  "ops.added.1drktj9": "Added",
  "ops.changed.12859ob": "Changed",
  "ops.no.longer.required.dlbq60": "No longer required",
  "ops.unchanged.68i9ge": "Unchanged",
  "ops.need.scheduling.or.information.62gqt4": "need scheduling or information",
  "ops.affected.shifts.bhvuz2": "affected shifts",
  "ops.started.and.completed.work.keeps.its.11uf855": "Started and completed work keeps its actual history. Changes to committed work are proposals for dispatcher review. Future bookings and completions beyond the known data horizon remain uncertain.",
  "ops.list.1360n8h": "List",
  "ops.preview.outcome.fic4cj": "Preview outcome",
  "ops.all.outcomes.1d360a9": "All outcomes",
  "ops.unit.property.1v1ozpr": "Unit / property",
  "ops.work.date.window.14urwqb": "Work date / window",
  "ops.outcome.spdxv": "Outcome",
  "ops.needs.scheduling.130a4po": "Needs scheduling",
  "ops.no.assignments.in.this.preview.range.10oc86m": "No assignments in this preview range.",
  "ops.previous.1t5jxvs": "Previous",
  "ops.next.1padbm0": "Next",
  "ops.mon.lti09t": "Mon",
  "ops.tue.1xk8o4l": "Tue",
  "ops.wed.walufr": "Wed",
  "ops.thu.1twqrw": "Thu",
  "ops.fri.anh0iw": "Fri",
  "ops.sat.fpw2nr": "Sat",
  "ops.sun.ijpse9": "Sun",
  "ops.assignments.r19a9l": "assignments",
  "ops.more.1sgpk2o": "more",
  "ops.clear.day.selection.ougwj6": "Clear day selection",
  "ops.no.assignments.on.this.day.9jg2gl": "No assignments on this day.",
  "ops.requirements.needing.attention.wcmejr": "Requirements needing attention",
  "ops.activation.summary.uiit5t": "Activation summary",
  "ops.enabled.units.1hytpml": "enabled units",
  "ops.shifts.will.receive.review.proposals.1xramd0": "shifts will receive review proposals",
  "ops.save.draft.7055cb": "Save draft",
  "ops.preview.active.changes.1wm2kde": "Preview active changes",
  "ops.preview.retirement.15703q": "Preview retirement",
  "ops.confirm.retirement.ymsv8e": "Confirm retirement",
  "ops.activate.changes.1rb8ewx": "Activate changes",
  "ops.activate.rule.1x26cu": "Activate rule",
  "ops.enter.a.service.name.positive.duration.oikpr2": "Enter a service name, positive duration, and crew size.",
  "ops.could.not.save.this.service.w6hm57": "Could not save this service.",
  "ops.service.definition.1xwou39": "Service definition",
  "ops.each.service.has.its.own.completion.vpw61c": "Each service has its own completion and execution requirements.",
  "ops.service.name.1j2ormv": "Service name",
  "ops.service.category.dk690k": "Service category",
  "ops.completion.updates.1a6i4bp": "Completion updates",
  "ops.no.unit.readiness.change.wqr6js": "No unit readiness change",
  "ops.cleaning.completed.inspection.may.remain.1g38w7r": "Cleaning completed · inspection may remain",
  "ops.inspection.passed.6fzv1": "Inspection passed",
  "ops.save.service.wnu47f": "Save service",
  "ops.view.q5w460": "View",
  "ops.previous.period.1eee7nd": "Previous period",
  "ops.next.period.das515": "Next period",
  "ops.period.start.pt0kw0": "Period start",
  "ops.close.details.1soutj5": "Close details",
  "ops.remove.skill.3brh64": "Remove skill",
  "ops.type.a.skill.and.press.enter.icua27": "Type a skill and press Enter",
  "ops.add.skill.ih3s8h": "Add skill",
  "ops.all.properties.6vtu5t": "All properties",
  "ops.back.1hzmxtu": "Back",
  "ops.shift.not.found.1mxlsnu": "Shift not found",
  "ops.this.link.does.not.identify.a.1fe2efj": "This link does not identify a saved shift.",
  "ops.back.to.shifts.hq9tqg": "Back to shifts",
  "ops.untitled.shift.1o3eg9o": "Untitled shift",
  "ops.positions.filled.17zlljh": "positions filled",
  "ops.combine.independent.work.and.working.availability.ig5cat": "Combine independent work and working availability into a clear operational plan.",
  "ops.create.shift.cd5ict": "Create shift",
  "ops.shift.lifecycle.pf30en": "Shift lifecycle",
  "ops.schedule.19hwlpo": "Schedule",
  "ops.drafts.ykz9u5": "Drafts",
  "ops.history.yugfpb": "History",
  "ops.all.wnjk2s": "All",
  "ops.search.shifts.5p6uu6": "Search shifts",
  "ops.all.dates.ry0hlt": "All dates",
  "ops.shifts.in.this.view.dys7qi": "shifts in this view",
  "ops.no.shifts.in.this.view.1pe5wv3": "No shifts in this view",
  "ops.try.another.period.or.create.a.lzqbpo": "Try another period or create a shift. Unplanned work remains available in Workload.",
  "ops.cleaning.1kkiraq": "Cleaning",
  "ops.saving.w7dncv": "Saving…",
  "ops.unsaved.changes.1tghr44": "Unsaved changes",
  "ops.saved.12ek4is": "Saved",
  "ops.saved.plan.1qwjz27": "Saved plan",
  "ops.no.changes.yet.6d06a1": "No changes yet",
  "ops.shift.history.wev5nj": "Shift history",
  "ops.save.now.19fkasg": "Save now",
  "ops.finish.shift.1mwdn3a": "Finish shift",
  "ops.review.plan.u3nuru": "Review & plan",
  "ops.review.start.uk4ub4": "Review / start",
  "ops.retry.save.xrvkye": "Retry save",
  "ops.export.recovery.draft.f877nx": "Export recovery draft",
  "ops.changes.affect.this.shift.current.facts.c0sw9f": "changes affect this shift. Current facts are already visible.",
  "ops.review.changes.hq25o": "Review changes",
  "ops.shift.details.10kbn6t": "Shift details",
  "ops.shift.name.vabw4m": "Shift name",
  "ops.start.30xvgf": "Start",
  "ops.end.1llf32i": "End",
  "ops.operational.note.1v70c6h": "Operational note",
  "ops.estimated.labor.5dz1vb": "estimated labor",
  "ops.shift.workspace.ikgzli": "Shift workspace",
  "ops.selected.work.and.eligible.candidates.192vga5": "Selected work and eligible candidates",
  "ops.draft.selections.are.tentative.planning.commits.f8142g": "Draft selections are tentative. Planning commits work atomically.",
  "ops.add.all.eligible.1y3oshc": "Add all eligible",
  "ops.add.manual.work.199mpb7": "Add manual work",
  "ops.search.shift.workload.1j2me6u": "Search shift workload",
  "ops.search.units.or.services.19g65zh": "Search units or services",
  "ops.no.eligible.work.for.this.shift.21a951": "No eligible work for this shift",
  "ops.nothing.is.selected.automatically.choose.another.pgxync": "Nothing is selected automatically. Choose another scope, create manual work, or inspect the independent workload.",
  "ops.estimated.workforce.t0i4st": "Estimated workforce",
  "ops.define.positions.and.coverage.then.choose.bdhm3u": "Define positions and coverage, then choose people. Partial participation is supported.",
  "ops.add.position.xysj3z": "Add position",
  "ops.people.suggested.wwzgf5": "people suggested",
  "ops.productive.coverage.1d59u4k": "productive coverage",
  "ops.add.suggested.positions.g23kaj": "Add suggested positions",
  "ops.estimate.assumptions.and.limits.n50u22": "Estimate assumptions and limits",
  "ops.position.1quewx6": "Position",
  "ops.unfilled.bcxrl2": "Unfilled",
  "ops.attendance.1eavko2": "Attendance",
  "ops.change.person.12oqne2": "Change person",
  "ops.choose.person.h1xrid": "Choose person",
  "ops.remove.position.ynhh5g": "Remove position",
  "ops.duty.f3u9v5": "Duty",
  "ops.coverage.starts.a5x1og": "Coverage starts",
  "ops.coverage.ends.w19b7z": "Coverage ends",
  "ops.required.skills.for.position.b00kvg": "Required skills for position",
  "ops.no.positions.yet.o8hfcg": "No positions yet",
  "ops.estimate.the.workforce.before.choosing.names.1aq5k1t": "Estimate the workforce before choosing names. Positions may remain unfilled in a planned shift.",
  "ops.removing.a.participant.keeps.their.independent.1irqo47": "Removing a participant keeps their independent workday. Availability gaps and existing commitments remain visible.",
  "ops.review.shift.sf4lzl": "Review shift",
  "ops.incomplete.staffing.can.be.planned.structural.a10slb": "Incomplete staffing can be planned. Structural conflicts prevent conflicting commitments; task requirements are enforced at execution.",
  "ops.continue.editing.1uyogj4": "Continue editing",
  "ops.start.shift.r7gpjz": "Start shift",
  "ops.plan.shift.1hmcuxy": "Plan shift",
  "ops.estimated.labor.1qw4r4n": "Estimated labor",
  "ops.uncovered.labor.143s3su": "Uncovered labor",
  "ops.pending.source.changes.1po2kf0": "Pending source changes",
  "ops.a.shift.can.start.while.some.on3y9d": "A shift can start while some units remain occupied. Each assignment requires its own current access, skills, crew, presence and dependencies before it can start.",
  "ops.review.scope.change.1gg51xr": "Review scope change",
  "ops.changing.the.scope.never.silently.replaces.1pwqt1t": "Changing the scope never silently replaces your selection.",
  "ops.keep.work.dates.release.incompatible.work.uf6w8m": "Keep work dates; release incompatible work",
  "ops.move.unstarted.work.with.shift.gxxz0r": "Move unstarted work with shift",
  "ops.selected.assignments.and.16tdq33": "selected assignments and",
  "ops.positions.will.be.checked.actual.sessions.1ddbr12": "positions will be checked. Actual sessions are preserved. Existing workday hours are not silently expanded or copied.",
  "ops.actual.sessions.and.audit.events.are.15nfgay": "Actual sessions and audit events are retained independently of the current plan.",
  "ops.legacy.records.retained.in.the.migration.hax780": "legacy records retained in the migration archive. Export the workspace to inspect original records.",
  "ops.save.failed.keep.your.work.1vm7gja": "Save failed — keep your work",
  "ops.your.last.committed.workspace.is.intact.r3b1ub": "Your last committed workspace is intact. You can retry, export this draft, or leave without its unsaved edits.",
  "ops.keep.editing.1mbnj4c": "Keep editing",
  "ops.export.draft.18hnja8": "Export draft",
  "ops.leave.without.unsaved.edits.wdakqz": "Leave without unsaved edits",
  "ops.enter.a.valid.working.interval.gnm1eu": "Enter a valid working interval.",
  "ops.choose.a.person.b8xx5o": "Choose a person",
  "ops.availability.skills.and.commitments.are.visible.ewzkxa": "Availability, skills and commitments are visible before selection.",
  "ops.search.people.and.skills.ugbgtt": "Search people and skills",
  "ops.available.in.this.coverage.window.p590nj": "available in this coverage window",
  "ops.missing.requested.skills.1gtj3k3": "Missing requested skills",
  "ops.already.committed.during.these.hours.11eocrq": "Already committed during these hours",
  "ops.include.1a27vnr": "Include",
  "ops.add.workday.p0b36p": "Add workday",
  "ops.this.creates.exactly.these.hours.in.k2tvd": "This creates exactly these hours in the workforce calendar and includes this person in the shift. Removing them later keeps their workday.",
  "ops.work.starts.lkib25": "Work starts",
  "ops.work.ends.kb0n7m": "Work ends",
  "ops.add.hours.and.include.1ev446": "Add hours and include",
  "ops.no.matching.people.1h4xg2g": "No matching people",
  "ops.change.your.search.or.add.a.6vh493": "Change your search or add a person in the independent directory.",
  "ops.finish.shift.and.hand.over.1hvjtm6": "Finish shift and hand over",
  "ops.every.unfinished.obligation.stays.accounted.for.grkccb": "Every unfinished obligation stays accounted for. Actual sessions, linen and deadlines are retained.",
  "ops.keep.shift.active.fjikva": "Keep shift active",
  "ops.complete.shift.j8xbbq": "Complete shift",
  "ops.choose.an.outcome.fzufhv": "Choose an outcome",
  "ops.return.to.workload.pool.13n7ytp": "Return to workload pool",
  "ops.continue.remaining.work.5as3tx": "Continue remaining work",
  "ops.decline.with.reason.15gfew5": "Decline with reason",
  "ops.transfer.to.n9img7": "Transfer to",
  "ops.handover.owner.7e9av5": "Handover owner",
  "ops.dispatcher.follow.up.1xs44l1": "Dispatcher follow-up",
  "ops.all.selected.assignments.are.accounted.for.1rek5dq": "All selected assignments are accounted for. This shift can be completed.",
  "ops.handover.note.decline.reason.11shccj": "Handover note / decline reason",
  "ops.choose.a.valid.start.time.and.d11otc": "Choose a valid start time and positive duration.",
  "ops.schedule.this.work.inside.the.shift.917zz9": "Schedule this work inside the shift interval.",
  "ops.the.required.crew.is.not.yet.1fwofer": "The required crew is not yet filled. This work cannot start until its crew is complete.",
  "ops.this.starts.before.the.current.service.7ds282": "This starts before the current service window.",
  "ops.this.ends.after.the.current.ready.dss40e": "This ends after the current ready-by deadline.",
  "ops.include.every.participant.in.this.shift.nljmtc": "Include every participant in this shift first.",
  "ops.choose.a.valid.start.and.duration.vwr8oy": "Choose a valid start and duration.",
  "ops.could.not.save.this.schedule.h61i91": "Could not save this schedule.",
  "ops.this.schedule.change.can.no.longer.5fa1qq": "This schedule change can no longer be undone.",
  "ops.shift.schedule.1pxwrbg": "Shift schedule",
  "ops.search.scheduled.assignments.or.people.cr8me4": "Search scheduled assignments or people",
  "ops.search.assignments.or.people.5i68ib": "Search assignments or people",
  "ops.undo.schedule.change.xnk7z0": "Undo schedule change",
  "ops.unassigned.f745fm": "Unassigned",
  "ops.actual.work.nagyi8": "Actual work",
  "ops.working.availability.is.shaded.all.times.1kuokzf": "Working availability is shaded. All times",
  "ops.tentative.schedule.1dy12z6": "Tentative schedule",
  "ops.assignment.10eds7k": "Assignment",
  "ops.participants.j7mvfr": "Participants",
  "ops.planned.interval.ca0pfi": "Planned interval",
  "ops.action.2wk0tb": "Action",
  "ops.required.people.l7oedf": "required people",
  "ops.not.scheduled.sgnw2l": "Not scheduled",
  "ops.no.assignments.to.show.i3ens6": "No assignments to show",
  "ops.add.work.in.the.workload.tab.1tbgatd": "Add work in the Workload tab or clear the current search.",
  "ops.schedule.lane.cdy80u": "Schedule lane",
  "ops.schedule.assignment.jljkst": "Schedule assignment",
  "ops.in.progress.bgdh5x": "In progress",
  "ops.actual.1v23pg7": "Actual",
  "ops.no.people.included.yet.17dakc1": "No people included yet",
  "ops.fill.staffing.positions.in.the.people.17vl92t": "Fill staffing positions in the People tab before scheduling individual work.",
  "ops.unassigned.assignments.1ci2w3k": "Unassigned assignments",
  "ops.drag.to.a.person.or.open.1xs2xv8": "Drag to a person or open Schedule. A drop always opens a preview before saving.",
  "ops.all.included.assignments.have.participants.and.14nj4wj": "All included assignments have participants and timing.",
  "ops.save.schedule.1np5zb9": "Save schedule",
  "ops.the.workspace.changed.while.this.preview.8q5jyz": "The workspace changed while this preview was open. Refresh the checks before saving.",
  "ops.refresh.checks.1jxlf2d": "Refresh checks",
  "ops.start.date.16seyg1": "Start date",
  "ops.start.time.slte8c": "Start time",
  "ops.duration.minutes.1ionhwt": "Duration (minutes)",
  "ops.clock.change.occurrence.hsu0tx": "Clock-change occurrence",
  "ops.ask.if.ambiguous.wp0lk1": "Ask if ambiguous",
  "ops.earlier.occurrence.1qohfvg": "Earlier occurrence",
  "ops.later.occurrence.1y5xhrm": "Later occurrence",
  "ops.timezone.1lch5qa": "Timezone",
  "ops.include.people.in.the.shift.before.2v2smh": "Include people in the shift before selecting participants.",
  "ops.scheduling.checks.1mx8go4": "Scheduling checks",
  "ops.several.participants.form.a.temporary.crew.1911uqa": "Several participants form a temporary crew for this assignment. Actual work, mandatory access, capabilities, presence, and dependencies are checked separately when starting.",
  "ops.apartment.cabfht": "Apartment",
  "ops.inherited.rule.re.enabled.for.this.7hn7ln": "Inherited rule re-enabled for this unit.",
  "ops.could.not.update.the.unit.rule.u2ub6s": "Could not update the unit rule exception.",
  "ops.give.a.reason.for.disabling.this.12mcc6h": "Give a reason for disabling this inherited rule.",
  "ops.could.not.disable.this.rule.l94fgl": "Could not disable this rule.",
  "ops.units.in.view.r680r0": "Units in view",
  "ops.vacancy.confirmed.ohm6sb": "Vacancy confirmed",
  "ops.need.attention.alkqaj": "Need attention",
  "ops.units.properties.ia1nlb": "Units & properties",
  "ops.luuta.owned.unit.facts.and.inherited.1cm9oj3": "Luuta-owned unit facts and inherited work rules, independent of any shift.",
  "ops.add.property.1isar0t": "Add property",
  "ops.add.unit.vh5raa": "Add unit",
  "ops.unit.management.views.654r7s": "Unit management views",
  "ops.properties.100clx8": "Properties",
  "ops.search.units.sa9m46": "Search units",
  "ops.search.unit.territory.or.tags.19z36tp": "Search unit, territory, or tags",
  "ops.show.archived.1d65u7e": "Show archived",
  "ops.effective.rules.1kdogu1": "Effective rules",
  "ops.latest.fact.1dmsyzs": "Latest fact",
  "ops.archived.1cnmmj7": "Archived",
  "ops.vacant.6pd5mi": "Vacant",
  "ops.occupied.1252i1": "Occupied",
  "ops.unknown.1kmy72x": "Unknown",
  "ops.changes.to.review.ov1t0l": "changes to review",
  "ops.open.unit.1omag1": "Open unit",
  "ops.no.units.match.these.filters.1ydv4rs": "No units match these filters",
  "ops.add.your.first.unit.1m2keux": "Add your first unit",
  "ops.clear.the.search.or.choose.another.i9kp63": "Clear the search or choose another property.",
  "ops.create.luuta.units.and.configure.their.6gid2j": "Create Luuta units and configure their own operational state and inherited rules.",
  "ops.clear.filters.a043pl": "Clear filters",
  "ops.edit.property.gzbcui": "Edit property",
  "ops.units.1jsp02k": "units",
  "ops.inherited.work.rules.11jrr31": "inherited work rules",
  "ops.view.units.12hnqnz": "View units",
  "ops.add.rule.1w18zz6": "Add rule",
  "ops.create.a.property.first.oif5v1": "Create a property first",
  "ops.a.property.groups.units.defines.their.bedrln": "A property groups units, defines their timezone, and owns inherited work rules.",
  "ops.current.access.hksymg": "Current access",
  "ops.access.permission.recorded.1eud4su": "Access permission recorded",
  "ops.cleaning.standard.1ltwbqv": "Cleaning standard",
  "ops.minutes.1c7ex2m": "minutes",
  "ops.effective.work.rules.19vksy4": "Effective work rules",
  "ops.property.rules.are.inherited.unit.rules.10hgwtw": "Property rules are inherited. Unit rules add work. Exceptions are explicit.",
  "ops.add.unit.rule.10ehjz4": "Add unit rule",
  "ops.disabled.here.1vwfy3d": "Disabled here",
  "ops.inherited.ytrxq9": "Inherited",
  "ops.reason.i36sl5": "Reason",
  "ops.open.property.rule.a2clkg": "Open property rule",
  "ops.edit.rule.1wfne7x": "Edit rule",
  "ops.re.enable.1j402s0": "Re-enable",
  "ops.disable.here.1q1stq7": "Disable here",
  "ops.no.effective.rules.k2mghs": "No effective rules",
  "ops.work.can.still.be.added.manually.zg4pys": "Work can still be added manually. Add a property rule or a unit-specific rule to generate assignments.",
  "ops.recent.unit.facts.1dzwwar": "Recent unit facts",
  "ops.no.recorded.fact.changes.yet.180n2ov": "No recorded fact changes yet.",
  "ops.archive.unit.17qyl99": "Archive unit",
  "ops.edit.unit.izjh5": "Edit unit",
  "ops.disable.inherited.rule.for.this.unit.pqzrao": "Disable inherited rule for this unit",
  "ops.other.units.keep.inheriting.this.rule.177k18m": "Other units keep inheriting this rule. This exception survives property-rule edits. Future unallocated demand is recalculated and committed shifts receive review proposals.",
  "ops.next.six.weeks.j37qyl": "Next six weeks",
  "ops.assignments.no.longer.generated.d7m328": "assignments no longer generated",
  "ops.shared.assignments.changed.1ufy5gi": "shared assignments changed",
  "ops.committed.shifts.need.review.caz4ja": "committed shifts need review",
  "ops.started.and.completed.work.remains.unchanged.stp52o": "Started and completed work remains unchanged. Compatible rules may continue requiring the same assignment.",
  "ops.disable.for.this.unit.1l7l2gu": "Disable for this unit",
  "ops.historical.bookings.work.and.actual.sessions.1pq0jkz": "Historical bookings, work, and actual sessions remain available. This unit will be excluded from future planning and rule generation.",
  "ops.unfinished.assignments.x0j9zu": "unfinished assignments",
  "ops.current.or.future.bookings.w02mq2": "current or future bookings",
  "ops.could.not.archive.this.unit.t32isz": "Could not archive this unit.",
  "ops.enter.a.unit.name.property.and.8hdmzg": "Enter a unit name, property, and positive cleaning standard.",
  "ops.could.not.save.the.unit.1ehg3kn": "Could not save the unit.",
  "ops.current.unit.facts.belong.to.luuta.x2s1t0": "Current unit facts belong to Luuta and remain independent of bookings and shifts.",
  "ops.unit.name.j78o4m": "Unit name",
  "ops.choose.property.1916v3d": "Choose property",
  "ops.property.change.impact.1ks6vvm": "Property change impact",
  "ops.inherited.rules.added.9t6lh0": "inherited rules added",
  "ops.inherited.rules.removed.1u21t3e": "inherited rules removed",
  "ops.future.unstarted.work.is.recalculated.existing.17ym3w3": "Future unstarted work is recalculated. Existing commitments receive review; historical work stays intact.",
  "ops.territory.1xb5go9": "Territory",
  "ops.unit.type.1uj3wt": "Unit type",
  "ops.access.permission.recorded.for.services.that.awsehl": "Access permission recorded for services that permit occupied access",
  "ops.cleaning.standard.minutes.fotozz": "Cleaning standard (minutes)",
  "ops.operational.notes.65bajy": "Operational notes",
  "ops.save.property.change.avhquv": "Save property change",
  "ops.save.unit.1jj9eti": "Save unit",
  "ops.enter.a.property.name.1fk9h2c": "Enter a property name.",
  "ops.could.not.save.the.property.15hat3y": "Could not save the property.",
  "ops.properties.own.operational.timezones.and.inherited.14up5vj": "Properties own operational timezones and inherited work rules.",
  "ops.property.name.c5j1a3": "Property name",
  "ops.operational.timezone.1uf4q9q": "Operational timezone",
  "ops.rules.calendar.days.and.service.windows.86vwgt": "Rules, calendar days, and service windows use this timezone rather than the browser timezone.",
  "ops.changing.timezone.affects.future.rule.projections.vk263g": "Changing timezone affects future rule projections. Existing actual timestamps remain unchanged; affected commitments need review.",
  "ops.save.property.afw8m9": "Save property",
  "ops.could.not.read.this.export.ij06gf": "Could not read this export.",
  "ops.could.not.apply.this.import.the.rsh707": "Could not apply this import. The previous calendar is unchanged.",
  "ops.quinyx.import.complete.zrp71x": "Quinyx import complete",
  "ops.import.quinyx.workdays.19j9yfu": "Import Quinyx workdays",
  "ops.read.the.file.resolve.identities.and.4yfc0n": "Read the file, resolve identities and changes, then apply one reviewed update.",
  "ops.review.import.fr306i": "Review import",
  "ops.applying.m2sarl": "Applying…",
  "ops.apply.reviewed.import.9cbmqp": "Apply reviewed import",
  "ops.import.steps.1697vfr": "Import steps",
  "ops.read.file.1rh1rch": "Read file",
  "ops.match.review.gyghaw": "Match & review",
  "ops.apply.summary.b3sz8f": "Apply summary",
  "ops.quinyx.daily.xlsx.export.1bz148r": "Quinyx daily XLSX export",
  "ops.the.supported.profile.reads.dated.working.lv8zyd": "The supported profile reads dated working intervals and employee identifiers when available. Split and overnight hours stay separate.",
  "ops.reading.file.1wynm4z": "Reading file…",
  "ops.choose.xlsx.file.1kcueqj": "Choose XLSX file",
  "ops.uploading.a.file.does.not.change.1byffcq": "Uploading a file does not change the calendar. No one will be assigned to a shift by this import.",
  "ops.quinyx.export.file.d968l1": "Quinyx export file",
  "ops.working.intervals.1yihkl2": "working intervals",
  "ops.verified.first.day.120qi49": "Verified first day",
  "ops.verified.last.day.15ns1id": "Verified last day",
  "ops.import.behavior.1at97im": "Import behavior",
  "ops.merge.supplied.rows.only.141wd9e": "Merge supplied rows only",
  "ops.replace.verified.source.snapshot.8rervy": "Replace verified source snapshot",
  "ops.source.export.time.optional.xkwb12": "Source export time (optional)",
  "ops.use.the.export.timestamp.not.the.103dfep": "Use the export timestamp, not the upload time.",
  "ops.invalid.source.timestamp.1crjc95": "Invalid source timestamp.",
  "ops.i.confirm.this.is.the.complete.1q4j11a": "I confirm this is the complete roster for the selected dates. Missing Quinyx-owned intervals may be removed; manual and shift-added hours remain unless explicitly replaced.",
  "ops.identity.and.change.review.8kqz6e": "Identity and change review",
  "ops.stable.employee.ids.match.automatically.name.lp6j4a": "Stable employee IDs match automatically. Name suggestions require your explicit selection.",
  "ops.use.unique.name.suggestions.ses2wb": "Use unique name suggestions",
  "ops.incoming.person.1swtg4m": "Incoming person",
  "ops.luuta.identity.xumfw0": "Luuta identity",
  "ops.current.incoming.hours.1uxxngu": "Current / incoming hours",
  "ops.id.0.1tc7g0r": "ID · {0}",
  "ops.no.source.employee.id.eau1iq": "No source employee ID",
  "ops.match.employee.rc9q2m": "Match employee",
  "ops.choose.identity.183ycqq": "Choose identity",
  "ops.create.new.person.uv8ecg": "Create new person",
  "ops.use.new.person.1cigwtv": "Use new person",
  "ops.suggested.gyac4s": "Suggested",
  "ops.keep.local.auidub": "Keep local",
  "ops.use.source.4618sp": "Use source",
  "ops.this.is.an.empty.dated.roster.6a3lt0": "This is an empty dated roster. A confirmed complete snapshot can remove source-owned intervals for this date; merge mode makes no removals.",
  "ops.independent.local.intervals.preserved.v7tge8": "Independent local intervals preserved",
  "ops.file.issues.1jj1uwt": "File issues",
  "ops.all.rows.are.resolved.review.the.fbkwld": "All rows are resolved. Review the final change summary before applying.",
  "ops.complete.source.snapshot.m2o5ox": "Complete source snapshot",
  "ops.merge.supplied.rows.d16bw0": "Merge supplied rows",
  "ops.the.workspace.changed.after.this.preview.124l10j": "The workspace changed after this preview. Refresh the comparison before applying.",
  "ops.what.this.operation.changes.mcwbkp": "What this operation changes",
  "ops.updates.only.reviewed.people.and.working.8t61sy": "Updates only reviewed people and working intervals in the declared period.",
  "ops.retains.local.decisions.shown.in.the.1uiaawa": "Retains local decisions shown in the comparison; source values remain available for later reconciliation.",
  "ops.flags.affected.shift.commitments.without.silently.e245ec": "Flags affected shift commitments without silently replanning them.",
  "ops.does.not.assign.anyone.to.a.1whtxq2": "Does not assign anyone to a shift or send anything to Quinyx.",
  "ops.source.intervals.to.remove.hvm1p9": "Source intervals to remove",
  "ops.the.reviewed.calendar.changes.are.saved.h2w7g5": "The reviewed calendar changes are saved.",
  "ops.the.run.is.recorded.in.integrations.3zdzeo": "The run is recorded in Integrations. Affected plans are available in Changes.",
  "ops.quinyx.daily.schedule.7z4nnh": "Quinyx daily schedule",
  "ops.no.supported.daily.schedule.was.found.12tugqc": "No supported daily schedule was found. Choose a Quinyx daily schedule XLSX export.",
  "ops.vuorotyyppi.1s938ub": "VUOROTYYPPI",
  "ops.the.employee.name.column.could.not.at8j7l": "The employee name column could not be identified.",
  "ops.row.0.invalid.working.hours.for.19v8fjc": "Row {0}: invalid working hours for {1}.",
  "ops.row.0.a.valid.workday.date.1ak8qct": "Row {0}: a valid workday date is missing for {1}.",
  "ops.the.export.has.no.verifiable.schedule.1l3pfdd": "The export has no verifiable schedule date. No existing workdays have been changed.",
  "ops.no.valid.working.intervals.were.found.1ff3z35": "No valid working intervals were found. Correct the invalid rows before importing.",
  "ops.quinyx.daily.xlsx.names.and.hours.184n0bm": "Quinyx daily XLSX · names and hours; employee ID/date when provided",
  "ops.choose.a.daily.schedule.export.smaller.1nix2s3": "Choose a daily schedule export smaller than 20 MB.",
  "ops.the.file.is.not.a.readable.18n74nv": "The file is not a readable XLSX export.",
  "ops.the.xlsx.file.contains.unreadable.worksheet.l5zd5": "The XLSX file contains unreadable worksheet data.",
  "ops.relationship.7fp6jf": "Relationship",
  "ops.target.12ohkdk": "Target",
  "ops.sha.256.1j0rdj1": "SHA-256",
  "ops.unsupported.worksheet.1cuk32i": "Unsupported worksheet.",
  "ops.no.supported.yqw24k": "No supported",
  "ops.no.supported.daily.schedule.worksheet.was.1yixf0b": "No supported daily schedule worksheet was found.",
  "ops.choose.a.valid.import.period.1kr3vvj": "Choose a valid import period.",
  "ops.confirm.that.this.export.covers.the.1eywsnn": "Confirm that this export covers the complete selected period before replacing missing rows.",
  "ops.snapshot.coverage.cannot.extend.beyond.the.1q08pty": "Snapshot coverage cannot extend beyond the dates verified in this export.",
  "ops.invalid.rows.prevent.complete.snapshot.replacement.1nbfdha": "Invalid rows prevent complete-snapshot replacement. Correct the file or use a merge import.",
  "ops.choose.a.valid.source.export.timestamp.qmn7w6": "Choose a valid source export timestamp.",
  "ops.this.export.is.older.than.the.z98qbn": "This export is older than the last applied source version. Review the newer source before applying.",
  "ops.cleaner.8mwovd": "Cleaner",
  "ops.match.employee.0.to.a.person.pe4wsl": "Match employee {0} to a person or explicitly create a new person.",
  "ops.invalid.local.time.t921iq": "Invalid local time.",
  "ops.resolve.the.ambiguous.or.invalid.local.1e4qzho": "Resolve the ambiguous or invalid local time.",
  "ops.no.incoming.row.16tocti": "No incoming row",
  "ops.independent.local.availability.is.preserved.44f5h3": "Independent local availability is preserved.",
  "ops.employee.1fak8xt": "Employee",
  "ops.complete.source.owned.intervals.in.the.s1mtv7": "Complete source-owned intervals in the verified period are replaced; local overrides remain explicit.",
  "ops.merge.only.missing.rows.do.not.18bd0nh": "Merge only; missing rows do not remove existing availability.",
  "ops.workforce.calendar.zezigj": "Workforce calendar",
  "ops.working.availability.is.independent.of.shift.1e8npgo": "Working availability is independent of shift assignments and actual attendance.",
  "ops.copy.workdays.4ygk3q": "Copy workdays",
  "ops.add.person.9jvr2h": "Add person",
  "ops.people.scheduled.in.this.week.1bcgm5c": "people scheduled in this week",
  "ops.working.availability.pvq90b": "working availability",
  "ops.unavailable.periods.4k97c3": "unavailable periods",
  "ops.search.people.or.skills.1co5gt": "Search people or skills",
  "ops.search.people.skills.or.employee.id.1n89e3q": "Search people, skills or employee ID",
  "ops.people.directory.fqavex": "People directory",
  "ops.people.skills.18nswk6": "People & skills",
  "ops.no.skills.specified.1mfyhza": "No skills specified",
  "ops.edit.workday.1reqwto": "Edit workday",
  "ops.unavailable.1okhrqh": "Unavailable",
  "ops.intervals.1db77f5": "intervals",
  "ops.from.shift.1na3nl1": "From shift",
  "ops.manual.1wu7r43": "Manual",
  "ops.no.workdays.in.this.period.1wgv0zq": "No workdays in this period",
  "ops.choose.a.calendar.day.copy.a.qlu6lx": "Choose a calendar day, copy a workday pattern, or import a verified Quinyx export.",
  "ops.no.people.match.your.filters.2m3jb4": "No people match your filters",
  "ops.clear.your.search.or.add.a.1eczzyw": "Clear your search or add a person to the directory.",
  "ops.working.intervals.must.end.after.they.19g0cg4": "Working intervals must end after they start. Use Next day for overnight work.",
  "ops.could.not.save.this.workday.dagumd": "Could not save this workday.",
  "ops.could.not.update.attendance.ktq15f": "Could not update attendance.",
  "ops.save.workday.1d1jnct": "Save workday",
  "ops.working.availability.1egfo3f": "Working availability",
  "ops.interval.1oxtjmg": "Interval",
  "ops.remove.interval.1fsu4za": "Remove interval",
  "ops.ends.next.day.fio6im": "Ends next day",
  "ops.interval.type.b5rpmo": "Interval type",
  "ops.working.1pyssg8": "Working",
  "ops.add.interval.1hg5yvh": "Add interval",
  "ops.saving.removes.availability.for.this.workday.1dd4sj4": "Saving removes availability for this workday. Existing shift commitments stay visible and receive a review warning.",
  "ops.intervals.may.cross.midnight.gaps.are.1kegd0s": "Intervals may cross midnight. Gaps are not counted as working time. Existing commitments are never deleted by a calendar edit.",
  "ops.next.day.v9b8iq": "Next day",
  "ops.shift.commitments.2ad43t": "Shift commitments",
  "ops.no.committed.shifts.overlap.this.day.1nicfe6": "No committed shifts overlap this day.",
  "ops.presence.is.separate.from.scheduled.working.7c9nl6": "Presence is separate from scheduled working hours.",
  "ops.mark.present.z1j8rv": "Mark present",
  "ops.mark.absent.1fmamo5": "Mark absent",
  "ops.could.not.copy.these.workdays.13rejob": "Could not copy these workdays.",
  "ops.review.the.people.dates.and.existing.52ki1s": "Review the people, dates, and existing hours before applying a workday pattern.",
  "ops.apply.workday.copy.wfvjin": "Apply workday copy",
  "ops.review.copy.qr8mxm": "Review copy",
  "ops.choose.a.valid.target.range.no.14ymnnr": "Choose a valid target range no longer than six weeks.",
  "ops.copy.hours.from.19laek1": "Copy hours from",
  "ops.first.target.day.zevzjk": "First target day",
  "ops.last.target.day.1zqgko": "Last target day",
  "ops.replace.existing.availability.on.the.target.1991i0b": "Replace existing availability on the target days",
  "ops.without.replacement.days.that.already.contain.lqsshi": "Without replacement, days that already contain intervals are skipped. No shift assignments or actual attendance are copied.",
  "ops.people.15ob10u": "people",
  "ops.target.days.drr5dv": "target days",
  "ops.existing.intervals.will.be.replaced.l275xd": "existing intervals will be replaced.",
  "ops.existing.intervals.will.be.preserved.fydqvf": "existing intervals will be preserved.",
  "ops.a.shared.directory.of.identities.capabilities.1vfe18y": "A shared directory of identities, capabilities, and duties. Working hours live in the calendar.",
  "ops.search.people.1o4cow0": "Search people",
  "ops.search.name.skill.or.external.id.ke9vua": "Search name, skill or external ID",
  "ops.include.archived.people.6w4nnm": "Include archived people",
  "ops.capabilities.by8rmn": "Capabilities",
  "ops.duties.994god": "Duties",
  "ops.external.identity.ivf0e4": "External identity",
  "ops.not.specified.als0rs": "Not specified",
  "ops.quinyx.0.15zy132": "Quinyx · {0}",
  "ops.no.people.found.1ykahl": "No people found",
  "ops.change.your.filters.or.add.someone.ng6xo7": "Change your filters or add someone to the shared directory.",
  "ops.could.not.save.this.person.3qaefh": "Could not save this person.",
  "ops.could.not.archive.this.person.9qstzm": "Could not archive this person.",
  "ops.names.are.display.values.identity.and.6sx4hf": "Names are display values. Identity and external mappings remain stable.",
  "ops.archive.person.1w857oi": "Archive person",
  "ops.save.person.6qo9tp": "Save person",
  "ops.edit.person.1y8h4fy": "Edit person",
  "ops.full.name.13z0t9r": "Full name",
  "ops.driver.1n5adbz": "Driver",
  "ops.inspector.lmgt1q": "Inspector",
  "ops.quinyx.employee.id.6w17gc": "Quinyx employee ID",
  "ops.use.the.stable.employee.identifier.from.1kvrhdh": "Use the stable employee identifier from the source. A matching name alone is not an identity mapping.",
  "ops.a.person.may.perform.several.duties.vc4d2a": "A person may perform several duties. Required capabilities are checked for the work they actually undertake.",
  "ops.upcoming.commitments.1i1wqrp": "Upcoming commitments",
  "ops.independent.work.clear.priorities.plan.each.xw5ze9": "Independent work, clear priorities. Plan each service once and retain every reason behind it.",
  "ops.add.assignment.2jid51": "Add assignment",
  "ops.search.assignments.1kqqy6b": "Search assignments",
  "ops.search.unit.property.or.service.1cflnf6": "Search unit, property or service",
  "ops.assignment.status.1pcunma": "Assignment status",
  "ops.assignments.in.this.view.ov884d": "assignments in this view",
  "ops.add.to.shift.9jt5fp": "Add to shift",
  "ops.move.zaagxg": "Move",
  "ops.decline.oo69tl": "Decline",
  "ops.undated.backlog.10t83k5": "Undated backlog",
  "ops.select.all.visible.assignments.c961t2": "Select all visible assignments",
  "ops.window.1s8mpdp": "Window",
  "ops.estimate.amg5ef": "Estimate",
  "ops.no.assignments.in.this.view.12mm7py": "No assignments in this view",
  "ops.change.the.period.or.filters.or.19uusly": "Change the period or filters, or add manual work. Rules generate work independently of shifts.",
  "ops.show.all.work.1f2t29k": "Show all work",
  "ops.move.selected.assignments.119wrz": "Move selected assignments",
  "ops.decline.selected.occurrences.tgzap0": "Decline selected occurrences",
  "ops.add.selected.work.to.a.shift.1razp4s": "Add selected work to a shift",
  "ops.assignments.will.be.reviewed.and.committed.16ea4hi": "assignments will be reviewed and committed together.",
  "ops.apply.to.selected.work.8o5p46": "Apply to selected work",
  "ops.new.date.1wmlkjb": "New date",
  "ops.choose.a.shift.1cqwseb": "Choose a shift",
  "ops.started.and.completed.work.retains.its.18u0zz4": "Started and completed work retains its history. Decline applies to these occurrences; future recurrences remain independent.",
  "ops.select.assignment.1eylv0u": "Select assignment",
  "ops.backlog.r6y1bc": "Backlog",
  "ops.rule.reasons.xd9l2q": "rule reasons",
  "ops.due.lfawnp": "Due",
  "ops.no.deadline.set.pmz11m": "No deadline set",
  "ops.allocated.hxv4ya": "Allocated",
  "ops.min.1jxbmtz": "min",
  "ops.save.assignment.1svptw1": "Save assignment",
  "ops.edit.assignment.1blgmm2": "Edit assignment",
  "ops.preferred.date.tsjkvy": "Preferred date",
  "ops.leave.empty.for.the.undated.backlog.18o6cir": "Leave empty for the undated backlog.",
  "ops.preferred.skills.rl9amg": "Preferred skills",
  "ops.approval.reference.149g2sn": "Approval reference",
  "ops.notes.4f76ga": "Notes",
  "ops.estimate.crew.1puax93": "Estimate / crew",
  "ops.cleaning.readiness.1b20lwq": "Cleaning readiness",
  "ops.current.conflicts.t4dnet": "Current conflicts",
  "ops.remove.from.shift.1ytrf6z": "Remove from shift",
  "ops.execution.1od8g6t": "Execution",
  "ops.start.work.i25wrs": "Start work",
  "ops.pause.j4z771": "Pause",
  "ops.complete.work.18s6p6z": "Complete work",
  "ops.inspection.failed.p5c8x4": "Inspection failed",
  "ops.restore.occurrence.1gsvd6": "Restore occurrence",
  "ops.move.to.another.date.n31z0e": "Move to another date",
  "ops.decline.this.occurrence.u8e9no": "Decline this occurrence",
  "ops.move.future.work.1d8q0gk": "Move future work",
  "ops.actual.work.and.linen.history.remain.1cme383": "Actual work and linen history remain. Declining this occurrence does not disable its rule or future recurrence.",
  "ops.confirm.18tbqwf": "Confirm",
  "ops.why.this.work.exists.12yvr7g": "Why this work exists",
  "ops.manually.requested.independent.service.hbn84h": "Manually requested independent service.",
  "ops.no.actual.sessions.recorded.104yd7": "No actual sessions recorded.",
  "ops.linen.operations.jhy0ab": "Linen operations",
  "ops.record.delivery.17htzac": "Record delivery",
  "ops.record.collection.1sj8keg": "Record collection",
  "ops.check.return.1wkxt8f": "Check return",
  "ops.missing.0.gabno5": "Missing {0}.",
  "ops.the.end.must.be.after.the.1cl706q": "The end must be after the start. Use an explicit next-day date for overnight work.",
  "ops.choose.an.existing.unit.and.service.o84azy": "Choose an existing unit and service.",
  "ops.choose.a.valid.workday.1x2rima": "Choose a valid workday.",
  "ops.duration.and.crew.size.must.be.13finro": "Duration and crew size must be positive whole numbers.",
  "ops.the.deadline.must.not.precede.the.yikong": "The deadline must not precede the earliest start.",
  "ops.an.assignment.cannot.depend.on.itself.1mp3urm": "An assignment cannot depend on itself.",
  "ops.choose.an.existing.person.and.a.1mzp55i": "Choose an existing person and a valid workday.",
  "ops.workday.intervals.overlap.including.an.interval.eis1ze": "Workday intervals overlap, including an interval on an adjacent date.",
  "ops.choose.a.property.and.valid.shift.7finoh": "Choose a property and valid shift date.",
  "ops.an.assignment.was.selected.more.than.10ja336": "An assignment was selected more than once.",
  "ops.a.selected.assignment.is.unavailable.review.qo4q5x": "A selected assignment is unavailable. Review the current workload.",
  "ops.a.selected.unit.belongs.to.another.1h3lrsg": "A selected unit belongs to another property.",
  "ops.a.selected.assignment.belongs.to.another.1jmxk1o": "A selected assignment belongs to another workday. Move it explicitly before planning this shift.",
  "ops.this.assignment.is.already.committed.to.bc2wdo": "This assignment is already committed to another shift.",
  "ops.participant.coverage.must.be.inside.the.sxgs3k": "Participant coverage must be inside the shift interval.",
  "ops.a.selected.person.is.unavailable.or.1qqt2d9": "A selected person is unavailable or archived.",
  "ops.one.person.cannot.fill.overlapping.positions.tdzkct": "One person cannot fill overlapping positions in the same shift.",
  "ops.this.person.is.committed.to.another.187uhky": "This person is committed to another shift during these hours. Choose different coverage or leave the position unfilled.",
  "ops.this.proposal.is.no.longer.pending.8o1lzo": "This proposal is no longer pending. Refresh the current changes.",
  "ops.record.why.the.commitment.is.kept.1tfakse": "Record why the commitment is kept. Current conflicts remain visible.",
  "ops.a.newer.proposal.supersedes.this.change.1xp3mn": "A newer proposal supersedes this change. Refresh the current impact review.",
  "ops.new.required.work.is.available.1pliana": "New required work is available",
  "ops.not.in.the.workload.3cpri7": "Not in the workload",
  "ops.unsupported.workspace.version.i17qk5": "Unsupported workspace version.",
  "ops.invalid.or.duplicate.0.identities.1v3y7ru": "Invalid or duplicate {0} identities.",
  "ops.a.unit.needs.an.existing.property.p42c9d": "A unit needs an existing property and a name.",
  "ops.an.assignment.has.an.invalid.unit.3tseh6": "An assignment has an invalid unit or service reference.",
  "ops.an.assignment.cannot.be.committed.to.121vf05": "An assignment cannot be committed to two shifts.",
  "ops.an.allocation.has.an.invalid.assignment.1g2bf6r": "An allocation has an invalid assignment or shift reference.",
  "ops.the.workspace.changed.since.this.preview.4os0s1": "The workspace changed since this preview. Refresh it before applying; your edits are preserved.",
  "ops.assignment.not.found.1hz7gg1": "Assignment not found.",
  "ops.shift.not.found.1m22nj0": "Shift not found.",
  "ops.enter.a.service.name.positive.duration.420chc": "Enter a service name, positive duration and crew size.",
  "ops.enter.a.unit.name.property.and.1cjlvj8": "Enter a unit name, property and positive cleaning standard.",
  "ops.unit.moved.to.another.property.8mkx6r": "Unit moved to another property",
  "ops.enter.the.person.s.name.y82hw0": "Enter the person’s name.",
  "ops.this.external.employee.identifier.belongs.to.k74r8h": "This external employee identifier belongs to another person. Resolve the mapping first.",
  "ops.choose.an.existing.unit.and.enter.6reu6": "Choose an existing unit and enter a booking name.",
  "ops.this.source.revision.is.older.than.v8xnn7": "This source revision is older than the current booking.",
  "ops.choose.at.least.two.confirmed.bookings.oqqvmj": "Choose at least two confirmed bookings in the same unit.",
  "ops.continuous.stay.segments.must.meet.on.7u63ri": "Continuous-stay segments must meet on consecutive booking boundaries.",
  "ops.confirm.this.is.the.same.continuous.1nvl59e": "Confirm this is the same continuous stay and record a reason. Matching names alone are not sufficient.",
  "ops.verified.external.guest.stay.identity.x2v25y": "Verified external guest/stay identity",
  "ops.continuous.stay.not.found.w82j0w": "Continuous stay not found.",
  "ops.this.rule.preview.is.stale.refresh.stfik9": "This rule preview is stale. Refresh it before activation.",
  "ops.choose.an.inherited.property.rule.for.1ey9k2d": "Choose an inherited property rule for this unit.",
  "ops.record.why.the.inherited.rule.is.q00y4n": "Record why the inherited rule is disabled here.",
  "ops.actual.work.cannot.be.rewritten.pause.1dckcuv": "Actual work cannot be rewritten. Pause and schedule the remainder or create rework.",
  "ops.choose.a.different.valid.workday.dkoc3x": "Choose a different valid workday.",
  "ops.pause.active.work.before.scheduling.the.13vdbkn": "Pause active work before scheduling the remainder; completed work cannot be moved.",
  "ops.started.or.completed.work.must.retain.1j1a26": "Started or completed work must retain its actual history. Pause active work first.",
  "ops.record.a.reason.for.declining.this.xirzw0": "Record a reason for declining this occurrence.",
  "ops.only.declined.or.cancelled.work.can.zqzkhz": "Only declined or cancelled work can be restored.",
  "ops.choose.existing.assignments.for.the.bulk.10xbxtp": "Choose existing assignments for the bulk action.",
  "ops.choose.a.draft.or.planned.shift.17tx7of": "Choose a draft or planned shift.",
  "ops.only.open.or.paused.work.can.we637u": "Only open or paused work can be added to this plan.",
  "ops.all.selected.work.must.match.the.3m1phb": "All selected work must match the shift property and workday. Move it explicitly first.",
  "ops.choose.a.valid.destination.workday.1qcgsaa": "Choose a valid destination workday.",
  "ops.record.a.reason.for.declining.these.9cvkns": "Record a reason for declining these occurrences.",
  "ops.active.and.completed.work.cannot.be.jyz9m5": "Active and completed work cannot be changed by this bulk action.",
  "ops.choose.a.supported.bulk.action.5dwdkj": "Choose a supported bulk action.",
  "ops.every.interval.must.belong.to.the.pusije": "Every interval must belong to the selected person and business date.",
  "ops.choose.a.valid.copy.period.no.i41xx3": "Choose a valid copy period no longer than one year.",
  "ops.choose.an.existing.person.spgfh9": "Choose an existing person.",
  "ops.closed.shifts.are.read.only.append.q5cmqk": "Closed shifts are read-only; append corrections through history.",
  "ops.an.active.shift.cannot.be.turned.1lu8owt": "An active shift cannot be turned back into a draft.",
  "ops.only.a.draft.or.planned.shift.1ncxj8r": "Only a draft or planned shift can be planned.",
  "ops.plan.this.shift.before.starting.it.1x6e0n6": "Plan this shift before starting it.",
  "ops.include.at.least.one.person.before.1i6myyu": "Include at least one person before starting the shift.",
  "ops.a.completed.shift.cannot.be.cancelled.pztln4": "A completed shift cannot be cancelled.",
  "ops.pause.active.work.before.cancelling.the.18rz1e4": "Pause active work before cancelling the shift.",
  "ops.closed.shift.scope.cannot.change.tbitn2": "Closed shift scope cannot change.",
  "ops.choose.a.valid.scope.1hspxnt": "Choose a valid scope.",
  "ops.a.shift.containing.actual.work.cannot.8rkgau": "A shift containing actual work cannot move to another property.",
  "ops.only.an.active.shift.can.be.pqigm0": "Only an active shift can be completed.",
  "ops.pause.or.complete.all.active.work.1wvsoam": "Pause or complete all active work before closing the shift.",
  "ops.choose.an.outcome.for.every.unfinished.1wsmejt": "Choose an outcome for every unfinished assignment.",
  "ops.declined.during.shift.closure.w7ezf5": "Declined during shift closure",
  "ops.choose.another.draft.or.planned.shift.t6ha9g": "Choose another draft or planned shift at the same property for transfer.",
  "ops.unfinished.work.retained.after.shift.closure.rntr16": "Unfinished work retained after shift closure.",
  "ops.choose.an.existing.draft.planned.or.1hqldle": "Choose an existing draft, planned or active shift and assignment.",
  "ops.include.this.work.in.the.shift.orl7u0": "Include this work in the shift before scheduling it.",
  "ops.only.unstarted.or.paused.work.can.47qcf5": "Only unstarted or paused work can be scheduled.",
  "ops.include.every.participant.in.the.shift.muhiix": "Include every participant in the shift first.",
  "ops.allocation.not.found.67wa3g": "Allocation not found.",
  "ops.pause.active.work.before.releasing.it.1njcmnm": "Pause active work before releasing it.",
  "ops.start.the.committed.shift.before.starting.1cbxqo": "Start the committed shift before starting this work.",
  "ops.only.open.or.paused.work.can.ftknsb": "Only open or paused work can start.",
  "ops.every.participant.must.be.included.in.19m7cm2": "Every participant must be included in the current shift coverage.",
  "ops.mark.every.participant.present.before.starting.s5gb35": "Mark every participant present before starting work.",
  "ops.a.participant.already.has.work.in.1abs2xn": "A participant already has work in progress. Pause it first.",
  "ops.this.work.is.not.eligible.to.cgptvf": "This work is not eligible to start yet.",
  "ops.the.current.ready.by.deadline.has.1mnl3kf": "The current ready-by deadline has passed. Resolve the service window before starting.",
  "ops.current.workday.availability.does.not.cover.p81an1": "Current workday availability does not cover every participant. Update the calendar first.",
  "ops.only.active.work.can.pause.12kqxky": "Only active work can pause.",
  "ops.start.the.work.before.recording.its.13d78qp": "Start the work before recording its completion.",
  "ops.inspection.failed.correct.the.recorded.defects.1ihf1qf": "Inspection failed. Correct the recorded defects before release.",
  "ops.choose.an.existing.unit.jodybg": "Choose an existing unit.",
  "ops.choose.a.valid.linen.operation.1uurq2q": "Choose a valid linen operation.",
  "ops.this.batch.preview.is.stale.refresh.r3849w": "This batch preview is stale. Refresh before applying.",
  "ops.every.selected.proposal.must.still.be.1v2fxwk": "Every selected proposal must still be pending.",
  "ops.choose.a.valid.outbound.synchronization.policy.1q0mrlz": "Choose a valid outbound synchronization policy.",
  "ops.eligible.update.simulated.no.external.system.17hobn8": "Eligible update simulated. No external system was contacted.",
  "ops.the.workspace.changed.after.this.import.182qr19": "The workspace changed after this import preview. Rebuild the preview before applying.",
  "ops.resolve.employee.mappings.and.invalid.rows.bckrv": "Resolve employee mappings and invalid rows before applying this import.",
  "ops.the.import.has.an.invalid.date.1fn6ml5": "The import has an invalid date scope.",
  "ops.this.source.revision.is.older.than.1wmb5v8": "This source revision is older than an already imported schedule for this period.",
  "ops.an.imported.employee.is.missing.a.7z4ufe": "An imported employee is missing a name.",
  "ops.an.external.employee.identifier.maps.to.4pg6cd": "An external employee identifier maps to multiple people.",
  "ops.only.source.owned.intervals.inside.a.5jhqlw": "Only source-owned intervals inside a complete snapshot scope may be removed.",
  "ops.an.imported.interval.lies.outside.the.13grtmq": "An imported interval lies outside the declared scope.",
  "ops.review.the.local.hour.override.before.180kchr": "Review the local hour override before replacing it with source values.",
  "ops.an.incoming.employee.schedule.is.older.l07dqn": "An incoming employee schedule is older than its current source revision.",
  "ops.unsupported.operation.0.bl7sg7": "Unsupported operation: {0}",
  "ops.turnover.cleaning.vffshb": "Turnover cleaning",
  "ops.could.not.load.browser.storage.1ghs6xm": "Could not load browser storage.",
  "ops.could.not.save.your.previous.data.12l7cn2": "Could not save. Your previous data has been preserved.",
  "ops.workspaceprovider.is.required.vl0nxk": "WorkspaceProvider is required.",
  "ops.browser.storage.is.unavailable.your.existing.1oxpsd3": "Browser storage is unavailable. Your existing data has not been changed.",
  "ops.could.not.open.browser.storage.wvi1ru": "Could not open browser storage.",
  "ops.close.another.older.luuta.tab.to.1vrsifb": "Close another older Luuta tab to finish updating browser storage.",
  "ops.this.workspace.uses.an.unsupported.data.670jpx": "This workspace uses an unsupported data version. Export a backup before upgrading.",
  "ops.could.not.read.the.workspace.existing.1facoms": "Could not read the workspace. Existing data has been preserved.",
  "ops.workspace.loading.was.cancelled.existing.data.14b9869": "Workspace loading was cancelled. Existing data has been preserved.",
  "ops.load.the.workspace.before.saving.changes.sgh7ep": "Load the workspace before saving changes.",
  "ops.could.not.save.the.previous.workspace.waw9ra": "Could not save. The previous workspace is unchanged.",
  "ops.give.the.rule.a.name.and.1gn1e9e": "Give the rule a name and choose an existing service.",
  "ops.choose.an.existing.rule.scope.1tb7lgc": "Choose an existing rule scope.",
  "ops.frequency.must.be.a.positive.whole.1kq25fp": "Frequency must be a positive whole number.",
  "ops.the.ready.by.deadline.must.not.1svtz63": "The ready-by deadline must not precede the earliest start.",
  "ops.work.estimates.and.crew.size.must.5mouql": "Work estimates and crew size must be positive.",
  "ops.choose.an.anchor.date.for.the.1wdjwfj": "Choose an anchor date for the calendar schedule.",
  "ops.allowed.working.hours.must.end.after.al1j3r": "Allowed working hours must end after they start.",
  "ops.choose.an.initial.anchor.date.15twcae": "Choose an initial anchor date.",
  "ops.set.a.first.due.anchor.or.1ye7q0p": "Set a first due anchor or record a qualifying completion.",
  "ops.review.the.local.clock.time.lpmzt2": "Review the local clock time.",
  "ops.the.local.trigger.time.is.ambiguous.jsurai": "The local trigger time is ambiguous or does not exist.",
  "ops.required.booking.information.is.missing.juvsq3": "Required booking information is missing.",
  "ops.review.the.local.working.hours.10iww7t": "Review the local working hours.",
  "ops.no.eligible.working.time.exists.before.p3wqca": "No eligible working time exists before the ready-by deadline.",
  "ops.work.requirements.changed.bbsyj0": "Work requirements changed",
  "ops.this.work.is.no.longer.required.vgw0n1": "This work is no longer required by the current rules",
  "ops.included.in.this.shift.116k3dc": "Included in this shift",
  "ops.return.obsolete.unstarted.work.to.history.139ugqo": "Return obsolete unstarted work to history",
  "ops.the.unit.is.missing.or.archived.27h3vn": "The unit is missing or archived.",
  "ops.choose.a.valid.service.18fdfo": "Choose a valid service.",
  "ops.this.service.requires.confirmed.vacancy.17j0csw": "This service requires confirmed vacancy.",
  "ops.confirm.actual.vacancy.before.starting.this.smsn04": "Confirm actual vacancy before starting this service.",
  "ops.the.vacancy.confirmation.predates.a.newer.137rmh7": "The vacancy confirmation predates a newer booking. Verify current access.",
  "ops.record.permission.to.enter.the.occupied.1cnegbr": "Record permission to enter the occupied unit.",
  "ops.complete.the.prerequisite.work.first.35bt6q": "Complete the prerequisite work first.",
  "ops.required.source.information.is.missing.yvr0tx": "Required source information is missing.",
  "ops.no.eligible.working.time.exists.before.1du433f": "No eligible working time exists before the deadline.",
  "ops.choose.a.workday.for.this.assignment.tzeh9a": "Choose a workday for this assignment.",
  "ops.scheduled.work.starts.before.the.eligible.1wd534a": "Scheduled work starts before the eligible service window.",
  "ops.scheduled.work.finishes.after.the.ready.91og2": "Scheduled work finishes after the ready-by deadline.",
  "ops.this.service.needs.0.participant.s.orzd8a": "This service needs {0} participant(s).",
  "ops.a.participant.is.missing.or.archived.1bpc5lw": "A participant is missing or archived.",
  "ops.a.participant.does.not.have.every.1cpsyxs": "A participant does not have every mandatory skill.",
  "ops.a.participant.is.currently.absent.m6dagk": "A participant is currently absent.",
  "ops.a.participant.is.not.available.for.tt4cdv": "A participant is not available for the scheduled interval.",
  "ops.this.participant.has.another.assignment.at.yfqudh": "This participant has another assignment at the same time.",
  "ops.a.staffing.position.is.unfilled.t3krxw": "A staffing position is unfilled.",
  "ops.this.person.is.missing.or.archived.1j965uv": "This person is missing or archived.",
  "ops.required.position.skills.are.not.covered.1761z20": "Required position skills are not covered.",
  "ops.participant.coverage.must.be.contained.in.1d36chl": "Participant coverage must be contained in the shift.",
  "ops.workday.intervals.do.not.cover.this.lg93xq": "Workday intervals do not cover this participation window.",
  "ops.this.person.is.currently.absent.13s1ro5": "This person is currently absent.",
  "ops.this.person.is.committed.to.another.sld5cn": "This person is committed to another shift during these hours.",
  "ops.estimates.use.service.duration.required.crew.bxb2iq": "Estimates use service duration × required crew, without automatic pair speedup.",
  "ops.availability.gaps.and.overlapping.duplicate.positions.1qakzyi": "Availability gaps and overlapping duplicate positions are excluded.",
  "ops.suggestion.reserves.30.minutes.per.full.11i8of6": "Suggestion reserves 30 minutes per full shift; capacity includes five minutes between assignments. Scheduling still needs review.",
  "ops.source.bookings.overlap.actual.vacancy.remains.1klvwb3": "Source bookings overlap. Actual vacancy remains unconfirmed.",
  "ops.only.completed.service.facts.can.be.cd6yup": "Only completed service facts can be synchronized.",
  "ops.a.newer.stay.began.after.this.8cu1xc": "A newer stay began after this completion. The old clean state must not be sent.",
  "ops.synchronization.is.disabled.by.policy.1t0oytw": "Synchronization is disabled by policy.",
  "ops.confirmed.checkout.is.required.for.the.1digrmg": "Confirmed checkout is required for the relevant current stay.",
  "ops.the.current.service.cycle.and.synchronization.45zt7p": "The current service cycle and synchronization policy allow this update.",
  "ops.enter.a.valid.date.and.time.xpto2o": "Enter a valid date and time.",
  "ops.enter.a.valid.calendar.date.1i9evb4": "Enter a valid calendar date.",
  "ops.enter.a.valid.local.date.and.xpvu25": "Enter a valid local date and time.",
  "ops.this.local.time.does.not.exist.nocl2p": "This local time does not exist because the clocks change. Choose another time.",
  "ops.this.local.time.occurs.twice.because.16qwym0": "This local time occurs twice because the clocks change. Choose the earlier or later occurrence.",
  "ops.status.vacant": "Vacant",
  "ops.status.occupied": "Occupied",
  "ops.status.unknown": "Unknown",
  "ops.status.dirty": "Dirty",
  "ops.status.cleaned": "Cleaned",
  "ops.status.inspection-needed": "Inspection needed",
  "ops.status.ready": "Ready",
  "ops.status.open": "Open",
  "ops.status.in-progress": "In progress",
  "ops.status.paused": "Paused",
  "ops.status.completed": "Completed",
  "ops.status.declined": "Declined",
  "ops.status.cancelled": "Cancelled",
  "ops.status.pending": "Pending",
  "ops.status.satisfied": "Satisfied",
  "ops.status.suppressed": "Suppressed",
  "ops.status.superseded": "Superseded",
  "ops.status.needs-information": "Needs information",
  "ops.status.needs-scheduling": "Needs scheduling",
  "ops.status.active": "Active",
  "ops.status.draft": "Draft",
  "ops.status.retired": "Retired",
  "ops.status.property": "Property",
  "ops.status.unit": "Unit",
  "ops.status.committed": "Committed",
  "ops.status.released": "Released",
  "ops.status.finished": "Finished",
  "ops.status.expected": "Expected",
  "ops.status.confirmed": "Confirmed",
  "ops.status.present": "Present",
  "ops.status.absent": "Absent",
  "ops.status.eligible": "Eligible",
  "ops.status.held": "Held",
  "ops.status.failed": "Failed",
  "ops.status.stale": "Stale",
  "ops.status.simulated": "Simulated",
  "ops.status.manual": "Manual",
  "ops.status.rule": "Rule",
  "ops.status.inspection": "Inspection",
  "ops.status.rework": "Rework",
  "ops.status.cleaning": "Cleaning",
  "ops.status.extra": "Extra work",
  "ops.status.other": "Other",
  "ops.status.all": "All",
  "ops.status.any": "Any",
  "ops.status.days": "Days",
  "ops.status.weeks": "Weeks",
  "ops.status.months": "Months",
  "ops.status.normal": "Normal",
  "ops.status.high": "High",
  "ops.status.applied": "Applied",
  "ops.status.kept": "Kept",
  "ops.status.warning": "Warning",
  "ops.status.blocker": "Blocking",
  "ops.status.info": "Information",
  "ops.count.assignments.few": "{count} assignments",
  "ops.count.assignments.other": "{count} assignments",
  "ops.count.assignments.many": "{count} assignments",
  "ops.count.assignments.one": "{count} assignment",
  "ops.count.changes.few": "{count} changes",
  "ops.count.changes.other": "{count} changes",
  "ops.count.changes.many": "{count} changes",
  "ops.count.changes.one": "{count} change",
  "ops.count.conflicts.few": "{count} conflicts",
  "ops.count.conflicts.other": "{count} conflicts",
  "ops.count.conflicts.many": "{count} conflicts",
  "ops.count.conflicts.one": "{count} conflict",
  "ops.count.positions.few": "{count} positions",
  "ops.count.positions.other": "{count} positions",
  "ops.count.positions.many": "{count} positions",
  "ops.count.positions.one": "{count} position",
  "ops.count.people.few": "{count} people",
  "ops.count.people.other": "{count} people",
  "ops.count.people.many": "{count} people",
  "ops.count.people.one": "{count} person",
  "ops.active.8qzyhb": "Active",
  "ops.local.workspace.storage.and.recovery.lh6v8m": "Local workspace storage and recovery.",
  "ops.completed.1tmo59u": "Completed",
  "ops.cancelled.1a3t1vg": "Cancelled",
  "ops.planned.1lkoe2t": "Planned",
  "ops.handover.1asx9be": "Handover",
  "ops.source.shift.das6l8": "Source shift",
  "ops.owner.171lv90": "Owner",
  "ops.choose.a.valid.preview.start.date.1hz6usj": "Choose a valid preview start date.",
  "ops.show.less.htx6fh": "Show less",
  "ops.show.all.requirements.8rxgp5": "Show all requirements",
  "ops.show.all.conflicts.1abkjuk": "Show all conflicts",
  "ops.draft.129n38s": "Draft",
  "ops.shift.1xakelj": "Shift",
  "ops.assignment.commitment.changed.17jde4d": "Assignment commitment changed",
  "ops.the.saved.workspace.is.not.readable.1dzasvl": "The saved workspace is not readable.",
  "ops.invalid.workspace.recovery.or.transaction.records.yfbg0r": "Invalid workspace recovery or transaction records.",
  "ops.invalid.integration.policy.7zhlua": "Invalid integration policy.",
  "ops.invalid.person.identity.or.capabilities.1o2uf0y": "Invalid person identity or capabilities.",
  "ops.invalid.service.definition.1xwn6ra": "Invalid service definition.",
  "ops.invalid.booking.identity.or.status.1n8tj00": "Invalid booking identity or status.",
  "ops.invalid.continuous.stay.references.qo81nz": "Invalid continuous-stay references.",
  "ops.invalid.saved.rule.definition.1nipvai": "Invalid saved rule definition.",
  "ops.invalid.assignment.fields.or.lifecycle.1btwlpr": "Invalid assignment fields or lifecycle.",
  "ops.invalid.generated.work.requirement.1q9rdk9": "Invalid generated work requirement.",
  "ops.invalid.workforce.interval.reference.1hhs91y": "Invalid workforce interval reference.",
  "ops.invalid.attendance.event.9y9a0v": "Invalid attendance event.",
  "ops.invalid.shift.structure.1v4l1sd": "Invalid shift structure.",
  "ops.invalid.staffing.position.hjut7h": "Invalid staffing position.",
  "ops.invalid.actual.work.session.1x4mwmz": "Invalid actual work session.",
  "ops.invalid.linen.operation.history.jryf4l": "Invalid linen operation history.",
  "ops.invalid.change.proposal.fh7o9s": "Invalid change proposal.",
  "ops.invalid.synchronization.intent.1ovlj4s": "Invalid synchronization intent.",
  "ops.invalid.import.run.history.1g6nuqa": "Invalid import run history.",
  "ops.invalid.operational.fact.provenance.sartwl": "Invalid operational fact provenance.",
  "ops.invalid.handover.records.sugod9": "Invalid handover records.",
  "ops.eligible.retry.simulated.no.external.system.1dc3tt5": "Eligible retry simulated. No external system was contacted.",
  "ops.rules.request.the.same.service.for.7a6ytr": "Rules request the same service for this cycle in incompatible windows. Separate requirements are retained for review.",
  "ops.status.resolved": "Resolved",
  "ops.a.property.needs.a.name.and.yncb3g": "A property needs a name and timezone.",
  "ops.a.unit.needs.an.existing.property.5do0ig": "A unit needs an existing property, a name and valid operational facts.",
  "ops.assignment.pages.o5u2fs": "Assignment pages",
  "ops.cancel.shift.1f6n8gb": "Cancel shift",
  "ops.unfinished.work.returns.to.the.pool.rl7tfq": "Unfinished work returns to the pool. Actual sessions, completed work, workdays, and linen history remain.",
  "ops.rule.summary.work": "Create {service} for {scope}.",
  "ops.rule.summary.afterservice": "After {service} is completed.",
  "ops.rule.repeat.days.one": "Repeat every {count} day.",
  "ops.rule.aftercompletion.days.one": "Due {count} day after the last qualifying completion.",
  "ops.rule.repeat.days.few": "Repeat every {count} days.",
  "ops.rule.aftercompletion.days.few": "Due {count} days after the last qualifying completion.",
  "ops.rule.repeat.days.many": "Repeat every {count} days.",
  "ops.rule.aftercompletion.days.many": "Due {count} days after the last qualifying completion.",
  "ops.rule.repeat.days.other": "Repeat every {count} days.",
  "ops.rule.aftercompletion.days.other": "Due {count} days after the last qualifying completion.",
  "ops.rule.repeat.weeks.one": "Repeat every {count} week.",
  "ops.rule.aftercompletion.weeks.one": "Due {count} week after the last qualifying completion.",
  "ops.rule.repeat.weeks.few": "Repeat every {count} weeks.",
  "ops.rule.aftercompletion.weeks.few": "Due {count} weeks after the last qualifying completion.",
  "ops.rule.repeat.weeks.many": "Repeat every {count} weeks.",
  "ops.rule.aftercompletion.weeks.many": "Due {count} weeks after the last qualifying completion.",
  "ops.rule.repeat.weeks.other": "Repeat every {count} weeks.",
  "ops.rule.aftercompletion.weeks.other": "Due {count} weeks after the last qualifying completion.",
  "ops.rule.repeat.months.one": "Repeat every {count} month.",
  "ops.rule.aftercompletion.months.one": "Due {count} month after the last qualifying completion.",
  "ops.rule.repeat.months.few": "Repeat every {count} months.",
  "ops.rule.aftercompletion.months.few": "Due {count} months after the last qualifying completion.",
  "ops.rule.repeat.months.many": "Repeat every {count} months.",
  "ops.rule.aftercompletion.months.many": "Due {count} months after the last qualifying completion.",
  "ops.rule.repeat.months.other": "Repeat every {count} months.",
  "ops.rule.aftercompletion.months.other": "Due {count} months after the last qualifying completion.",
  "ops.rule.stay.nights.one": "During a stay, repeat every {count} night.",
  "ops.rule.stay.nights.few": "During a stay, repeat every {count} nights.",
  "ops.rule.stay.nights.many": "During a stay, repeat every {count} nights.",
  "ops.rule.stay.nights.other": "During a stay, repeat every {count} nights.",
  "ops.booking.not.found.1pvhmqp": "Booking not found.",
  "ops.this.link.does.not.identify.an.zrlvwo": "This link does not identify an available record.",
  "ops.reload.current.record.1l7jcde": "Reload current record",
  "ops.a.command.needs.a.stable.identity.5uqhan": "A command needs a stable identity and valid effective time.",
  "ops.this.record.changed.since.it.was.bomin8": "This record changed since it was opened. Refresh the record before saving; your edits are preserved.",
  "ops.assignment.dependencies.cannot.form.a.cycle.1sh6ytv": "Assignment dependencies cannot form a cycle.",
  "ops.choose.existing.prerequisite.assignments.xkzny7": "Choose existing prerequisite assignments.",
  "ops.this.shift.is.closed.review.its.vf60ex": "This shift is closed. Review its current follow-up work without rewriting the historical plan.",
  "ops.choose.a.valid.preview.period.bjbtr8": "Choose a valid preview period.",
  "ops.use.the.assignment.lifecycle.action.to.xe7acf": "Use the assignment lifecycle action to change its status.",
  "ops.requirement.provenance.and.actual.completion.facts.2qu6gc": "Requirement provenance and actual completion facts cannot be edited through assignment details.",
  "ops.rule.requirements.retain.their.unit.and.zvauvp": "Rule requirements retain their unit and service. Create separate manual work for a different obligation.",
  "ops.choose.a.draft.planned.or.active.1vg08ev": "Choose a draft, planned or active shift.",
  "ops.use.the.shift.lifecycle.action.to.6i9kxy": "Use the shift lifecycle action to change its status.",
  "ops.shift.execution.and.cancellation.facts.are.k148lq": "Shift execution and cancellation facts are recorded through lifecycle actions.",
  "ops.this.shift.is.already.cancelled.gqcrna": "This shift is already cancelled.",
  "ops.record.a.reason.for.cancelling.the.9xfrc3": "Record a reason for cancelling the shift.",
  "ops.a.shift.containing.actual.work.must.1kwanjz": "A shift containing actual work must retain its date and time boundaries. Move the remaining work through a continuation.",
  "ops.record.a.reason.for.declining.unfinished.1mtt5dd": "Record a reason for declining unfinished work.",
  "ops.choose.an.available.person.to.own.ctisuy": "Choose an available person to own the handover.",
  "ops.pause.active.work.before.changing.its.1jvm8uj": "Pause active work before changing its schedule.",
  "ops.historical.allocations.cannot.be.released.create.qt6plj": "Historical allocations cannot be released. Create a new continuation for remaining work.",
  "ops.choose.source.local.or.review.ownership.n3ulam": "Choose source, local, or review ownership for each synchronized field.",
  "ops.the.relevant.source.booking.changed.after.15xqwnw": "The relevant source booking changed after this update was queued. Re-evaluate the current service cycle.",
  "ops.rule.preview.cancelled.t24jm": "Rule preview cancelled.",
  "ops.the.unit.now.belongs.to.another.iesrbk": "The unit now belongs to another property. Review its shift commitment.",
  "ops.this.service.does.not.produce.a.1wp0sow": "This service does not produce a cleaning or guest-readiness fact.",
  "ops.guest.ready.release.requires.a.passed.1y0o621": "Guest-ready release requires a passed inspection and current readiness.",
  "ops.count.assignmentsInView.one": "{count} assignment in this view",
  "ops.count.assignmentsInView.few": "{count} assignments in this view",
  "ops.count.assignmentsInView.many": "{count} assignments in this view",
  "ops.count.assignmentsInView.other": "{count} assignments in this view",
  "ops.count.shiftsInView.one": "{count} shift in this view",
  "ops.count.shiftsInView.few": "{count} shifts in this view",
  "ops.count.shiftsInView.many": "{count} shifts in this view",
  "ops.count.shiftsInView.other": "{count} shifts in this view",
  "ops.actual.work.is.protected.keep.the.rsl9v4": "Actual work is protected. Keep the original property, date and time boundaries; schedule remaining work through a continuation.",
  "ops.protected.actual.work.yx17he": "Protected actual work",
  "ops.incompatible.property.1rems55": "Incompatible property",
  "ops.moves.to.target.date.1fpcif5": "Moves to target date",
  "ops.stays.in.shift.xpwcgs": "Stays in shift",
  "ops.outside.the.target.shift.s.work.1gxqv2d": "Outside the target shift's work window",
  "ops.scheduled.times.will.need.replanning.136gxf4": "Scheduled times will need replanning.",
  "ops.these.hours.are.already.covered.or.sqbg4c": "These hours are already covered or marked unavailable.",
  "ops.add.working.hours.1wp8xl0": "Add working hours",
  "ops.existing.working.hours.and.unavailable.periods.9se2t8": "Existing working hours and unavailable periods are preserved. Review the additional intervals before including this person.",
  "ops.planning.1vvl51g": "Planning",
  "ops.demo.62dmc6": "Demo",
  "ops.items.to.review.s560d4": "items to review",
  "ops.current.operational.problems.16hw82m": "Current operational problems",
  "ops.review.in.plan.vl5lhv": "Review in plan",
  "ops.invalid.operational.clock.anchor.1wmi4rf": "Invalid operational clock anchor.",
  "ops.invalid.workspace.identity.or.operational.clock.1qkk7vy": "Invalid workspace identity or operational clock.",
  "ops.invalid.planning.session.identities.1vinhnl": "Invalid planning session identities.",
  "ops.invalid.saved.planning.session.qf9772": "Invalid saved planning session.",
  "ops.this.command.belongs.to.another.workspace.180tjkv": "This command belongs to another workspace. Reopen the intended workspace before applying it.",
  "ops.choose.an.editable.planning.session.in.1h5fkz0": "Choose an editable planning session in this workspace.",
  "ops.this.planning.session.changed.reload.its.180rkyn": "This planning session changed. Reload its current proposal; your edits are preserved.",
  "ops.a.new.planning.session.must.start.btxnza": "A new planning session must start at revision zero.",
  "ops.choose.the.current.editable.planning.session.o12dcz": "Choose the current editable planning session.",
  "ops.the.plan.preview.is.stale.review.1jfglxq": "The plan preview is stale. Review current facts and refresh the proposal before applying.",
  "ops.the.committed.shift.changed.after.this.17s09zl": "The committed shift changed after this proposal. Rebase before applying.",
  "ops.the.repair.preview.expired.as.operational.7tupf4": "The repair preview expired as operational time advanced. Refresh it before applying.",
  "ops.a.reviewed.change.is.no.longer.1d34ez2": "A reviewed change is no longer current. Refresh the selected proposals.",
  "ops.reviewed.with.the.applied.plan.current.wew0o3": "Reviewed with the applied plan. Current conflicts remain visible.",
  "ops.historical.allocations.and.their.ownership.cannot.ah283z": "Historical allocations and their ownership cannot be overwritten.",
  "ops.the.planning.proposal.has.an.invalid.infmbg": "The planning proposal has an invalid structure.",
  "ops.planning.changes.cannot.rewrite.lifecycle.or.1asupgm": "Planning changes cannot rewrite lifecycle or execution facts.",
  "ops.choose.a.valid.property.workday.and.dpahhl": "Choose a valid property, workday, and shift interval.",
  "ops.closed.shifts.retain.their.historical.plan.18yize2": "Closed shifts retain their historical plan.",
  "ops.an.assignment.cannot.appear.twice.in.tq00cq": "An assignment cannot appear twice in the same plan.",
  "ops.each.staffing.position.needs.its.own.1ht0d1y": "Each staffing position needs its own identity.",
  "ops.release.only.current.allocations.owned.by.16rvixq": "Release only current allocations owned by this shift.",
  "ops.the.proposed.workday.change.is.stale.11wn4wy": "The proposed workday change is stale. Review the current calendar.",
  "ops.choose.an.existing.person.and.a.nm7fc1": "Choose an existing person and a valid workday interval.",
  "ops.each.assignment.has.one.proposed.allocation.142mhpl": "Each assignment has one proposed allocation.",
  "ops.include.existing.work.in.this.shift.1x3305y": "Include existing work in this shift before scheduling it.",
  "ops.completed.or.declined.work.cannot.receive.5rs2br": "Completed or declined work cannot receive a new allocation.",
  "ops.the.required.crew.is.not.yet.1wwqmmz": "The required crew is not yet filled.",
  "ops.this.assignment.has.no.time.slot.13knywu": "This assignment has no time slot yet.",
  "ops.this.unstarted.task.has.a.time.1ixy1d0": "This unstarted task has a time slot in the past.",
  "ops.this.work.misses.the.current.ready.1ejftty": "This work misses the current ready-by deadline. The missed deadline remains recorded.",
  "ops.confirm.the.required.access.before.starting.1mjtyl3": "Confirm the required access before starting this service.",
  "ops.include.every.available.participant.in.this.2lzf25": "Include every available participant in this shift first.",
  "ops.the.assignment.exceeds.the.participant.coverage.1hgnaj6": "The assignment exceeds the participant coverage window.",
  "ops.working.intervals.do.not.cover.this.gs08f2": "Working intervals do not cover this time.",
  "ops.complete.or.schedule.the.prerequisite.work.1ay4zo8": "Complete or schedule the prerequisite work before this task.",
  "ops.every.selected.assignment.needs.a.proposed.ecdyx2": "Every selected assignment needs a proposed allocation.",
  "ops.completed.work.cannot.be.included.in.nnvuks": "Completed work cannot be included in a different shift.",
  "ops.only.selected.unstarted.or.paused.work.1au7h9o": "Only selected unstarted or paused work can move to a valid workday.",
  "ops.estimated.work.exceeds.the.available.productive.1e0zfm8": "Estimated work exceeds the available productive capacity.",
  "ops.choose.existing.repair.groups.12as6fo": "Choose existing repair groups.",
  "ops.resolve.this.repair.group.before.applying.u4vwnx": "Resolve this repair group before applying it.",
  "ops.the.repair.belongs.to.another.shift.5qv92l": "The repair belongs to another shift.",
  "ops.choose.a.future.anchor.time.for.eivppn": "Choose a future anchor time for this unfinished work.",
  "ops.dependencies.prevent.a.deterministic.repair.review.10pcywt": "Dependencies prevent a deterministic repair. Review the prerequisite order.",
  "ops.pause.or.complete.the.active.session.1luuplf": "Pause or complete the active session before repairing this crew’s following work.",
  "ops.record.the.remaining.work.before.repairing.gl7l7s": "Record the remaining work before repairing this unfinished task.",
  "ops.choose.the.complete.crew.before.repairing.13dx8uy": "Choose the complete crew before repairing this task.",
  "ops.choose.an.available.qualified.crew.before.1j1y0ki": "Choose an available qualified crew before repairing this task.",
  "ops.the.prerequisite.has.no.feasible.placement.m3ezza": "The prerequisite has no feasible placement. Resolve it first.",
  "ops.no.common.slot.fits.the.crew.1rdp5id": "No common slot fits the crew, working intervals, and service window. Work remains in the plan.",
  "ops.the.prerequisite.cannot.finish.before.this.1hnf35t": "The prerequisite cannot finish before this task in the repaired plan.",
  "ops.repair.preserves.crew.estimates.workday.hours.chhwh5": "Repair preserves crew, estimates, workday hours, actual history, and external commitments.",
  "ops.no.feasible.common.slot.leaves.the.1h45wop": "No feasible common slot leaves the work unchanged for dispatcher review.",
  "ops.workspace.recovery.13gadp9": "Workspace recovery",
  "ops.restored.workspace.1ky5bry": "Restored workspace",
  "ops.operational.time.1ug6vk8": "Operational time",
  "ops.a.fresh.demo.is.activated.once.1ms91g0": "A fresh demo is activated once. Existing data is retained in a backup. Restoring creates a separate workspace copy with its original record identities.",
  "ops.start.fresh.demo.129zizq": "Start fresh demo",
  "ops.refresh.backups.1xkqt4z": "Refresh backups",
  "ops.review.fresh.demo.activation.1dhrfes": "Review fresh demo activation",
  "ops.review.workspace.restoration.1tvr9q8": "Review workspace restoration",
  "ops.the.current.saved.workspace.will.be.1txeuag": "The current saved workspace will be backed up before switching. Unsaved edits are not included. Original records and earlier backups remain available.",
  "ops.back.up.and.start.fresh.189twm6": "Back up and start fresh",
  "ops.restore.as.new.workspace.wex400": "Restore as new workspace",
  "ops.earlier.workspace.1pooeoy": "Earlier workspace",
  "ops.download.backup.qtrymx": "Download backup",
  "ops.restore.copy.1bu1j6y": "Restore copy",
  "ops.original.data.is.preserved.for.review.cr8wty": "Original data is preserved for review. This backup cannot be restored automatically.",
  "ops.no.backups.yet.starting.a.new.16m3iok": "No backups yet. Starting a new demo will preserve this workspace first.",
  "ops.before.redesign.v3.activation.1ezljj5": "Before redesign-v3 activation",
  "ops.preserved.legacy.data.1qet50a": "Preserved legacy data",
  "ops.before.restoring.a.workspace.copy.1aoif9y": "Before restoring a workspace copy",
  "ops.before.starting.a.fresh.demo.1pyp390": "Before starting a fresh demo",
  "ops.workspace.not.found.choose.an.available.1c5uv5f": "Workspace not found. Choose an available workspace or restore a backup.",
  "ops.the.command.targets.another.workspace.reload.r64uz1": "The command targets another workspace. Reload before saving.",
  "ops.the.command.targets.another.workspace.1mhmwqp": "The command targets another workspace.",
  "ops.backup.not.found.11psr8": "Backup not found.",
  "ops.simulated.storage.failure.the.previous.workspace.6jx4o4": "Simulated storage failure. The previous workspace is unchanged.",
  "ops.could.not.restore.the.workspace.1h571rb": "Could not restore the workspace.",
  "ops.could.not.start.a.fresh.demo.111jdqr": "Could not start a fresh demo.",
  "ops.count.reviewItems.one": "{count} item to review",
  "ops.count.reviewItems.few": "{count} items to review",
  "ops.count.reviewItems.many": "{count} items to review",
  "ops.count.reviewItems.other": "{count} items to review",
  "ops.no.workspace.xqgu2n": "No workspace",
  "ops.workspace.not.found.1y7hz8b": "Workspace not found.",
  "ops.a.shift.containing.actual.work.must.uogkbh": "A shift containing actual work must retain its date and time boundaries.",
  "ops.a.selected.person.is.missing.or.1q3a1tv": "A selected person is missing or archived.",
  "ops.a.participant.cannot.fill.two.places.fy8tiu": "A participant cannot fill two places in the same task.",
  "ops.a.selected.assignment.is.unavailable.1jv1gy6": "A selected assignment is unavailable.",
  "ops.a.selected.assignment.belongs.to.another.hp3wjx": "A selected assignment belongs to another workday.",
  "ops.edit.task.time.1wz2ojj": "Edit task time",
  "ops.place.in.schedule.8gw1b4": "Place in schedule",
  "ops.crew.not.filled.1o93va3": "Crew not filled",
  "ops.from.6s9hn9": "From",
  "ops.people.and.schedule.2izk4g": "People and schedule",
  "ops.choose.work.for.this.plan.1fdf31t": "Choose work for this plan",
  "ops.add.work.from.the.list.then.1oi1awt": "Add work from the list, then place it with a person and time.",
  "ops.edit.shift.hours.1tmnam2": "Edit shift hours",
  "ops.resize.planned.duration.11x3enh": "Resize planned duration",
  "ops.add.people.to.start.arranging.work.i4cgq4": "Add people to start arranging work",
  "ops.workdays.stay.independent.choose.available.people.17gb1sr": "Workdays stay independent. Choose available people or add explicit working hours.",
  "ops.add.people.1pyhdrz": "Add people",
  "ops.unfilled.staffing.need.xe2dt0": "Unfilled staffing need",
  "ops.any.skills.qlzud9": "Any skills",
  "ops.dashed.previous.violet.proposed.61ashn": "Dashed = previous · Violet = proposed",
  "ops.choose.work.19vqiz1": "Choose work",
  "ops.arrange.time.11yqkg4": "Arrange time",
  "ops.review.confirm.16oee47": "Review & confirm",
  "ops.choose.an.available.shift.or.start.1vjmubn": "Choose an available shift or start a new plan.",
  "ops.back.to.planning.lg8148": "Back to planning",
  "ops.add.a.property.to.begin.1cag7us": "Add a property to begin",
  "ops.a.property.gives.your.plan.its.1ucc0je": "A property gives your plan its units and operational timezone.",
  "ops.staffing.need.1kq05h1": "Staffing need",
  "ops.shift.plan.173jyxe": "Shift plan",
  "ops.planning.property.197uwbh": "Planning property",
  "ops.planning.workday.1fuu0a9": "Planning workday",
  "ops.selected.shift.1lyl8ag": "Selected shift",
  "ops.planning.presentation.1yzol78": "Planning presentation",
  "ops.board.1hpelzf": "Board",
  "ops.guided.adiae5": "Guided",
  "ops.more.planning.actions.df3om": "More planning actions",
  "ops.completed.shifts.1mvny6n": "Completed shifts",
  "ops.planning.steps.wrkl2v": "Planning steps",
  "ops.add.work.1mv4361": "Add work",
  "ops.selected.unscheduled.1wpym32": "selected unscheduled",
  "ops.capacity.serueh": "Capacity",
  "ops.timeline.djv8ja": "Timeline",
  "ops.unsaved.boibkp": "Unsaved",
  "ops.draft.saved.hox9mn": "Draft saved",
  "ops.resume.time.edit.17owl41": "Resume time edit",
  "ops.replan.2xk11f": "Replan",
  "ops.continue.to.people.hg85w": "Continue to people",
  "ops.continue.to.timing.1or4pqx": "Continue to timing",
  "ops.review.plan.1gwfcuk": "Review plan",
  "ops.current.facts.changed.your.edits.are.cfnkpf": "Current facts changed. Your edits are preserved.",
  "ops.review.latest.facts.1xhlyl3": "Review latest facts",
  "ops.discard.proposed.edits.1yv10f8": "Discard proposed edits",
  "ops.proposed.changes.clu33y": "proposed changes",
  "ops.draft.selections.do.not.reserve.work.dc8jkk": "Draft selections do not reserve work or people.",
  "ops.current.commitments.remain.until.you.apply.1vrjhxv": "Current commitments remain until you apply.",
  "ops.discard.8g1qg1": "Discard",
  "ops.plan.updated.156zs81": "Plan updated",
  "ops.undo.vmlwpb": "Undo",
  "ops.back.to.schedule.1u2zb00": "Back to schedule",
  "ops.planning.inspector.55yf3x": "Planning inspector",
  "ops.move.unfinished.work.1elxfp2": "Move unfinished work",
  "ops.new.workday.j6blik": "New workday",
  "ops.the.work.returns.to.the.pool.1kw6jnf": "The work returns to the pool on that day. Actual history and missed deadlines remain.",
  "ops.review.move.8qz1iy": "Review move",
  "ops.close.history.h4psvf": "Close history",
  "ops.close.attention.panel.1sdel0f": "Close attention panel",
  "ops.current.fact.e2xg38": "Current fact",
  "ops.repair.plan.q5v25r": "Repair plan",
  "ops.reason.for.keeping.commitment.1vq63ia": "Reason for keeping commitment",
  "ops.record.decision.12w0ui2": "Record decision",
  "ops.an.unresolved.execution.blocker.remains.visible.1eou0g4": "An unresolved execution blocker remains visible.",
  "ops.nothing.needs.attention.in.this.shift.o8uae2": "Nothing needs attention in this shift.",
  "ops.preview.a.repair.u1x4g1": "Preview a repair",
  "ops.work.details.execution.1dxwr42": "Work details & execution",
  "ops.move.day.1r17xy": "Move day",
  "ops.unfinished.work.returns.to.the.pool.dax6tt": "Unfinished work returns to the pool. Actual history and workdays remain.",
  "ops.manual.work.15uet6c": "Manual work",
  "ops.search.work.ma0i86": "Search work",
  "ops.unit.or.service.1w7fykf": "Unit or service",
  "ops.this.workday.8hg118": "This workday",
  "ops.remove.from.plan.g6mksu": "Remove from plan",
  "ops.add.to.plan.11skxxk": "Add to plan",
  "ops.person.1mpjerk": "person",
  "ops.flexible.start.1fqguhu": "Flexible start",
  "ops.committed.elsewhere.1c8x2qh": "Committed elsewhere",
  "ops.no.undated.work.matches.this.view.ulng9m": "No undated work matches this view.",
  "ops.no.work.matches.this.workday.check.225fou": "No work matches this workday. Check the backlog or add manual work.",
  "ops.enter.valid.working.hours.z4bi13": "Enter valid working hours.",
  "ops.choose.working.hours.that.overlap.this.110apwg": "Choose working hours that overlap this shift.",
  "ops.staffing.needs.1637cmq": "Staffing needs",
  "ops.name.or.skill.hr95r2": "Name or skill",
  "ops.unfilled.need.yif7mq": "Unfilled need",
  "ops.remove.need.1g487i3": "Remove need",
  "ops.add.staffing.need.1xm7pde": "Add staffing need",
  "ops.no.listed.skills.1yf7q8r": "No listed skills",
  "ops.included.1f8pot5": "Included",
  "ops.add.hours.6bo87n": "Add hours",
  "ops.available.skramw": "available",
  "ops.another.shift.1e0jo0o": "Another shift",
  "ops.this.shift.1qmyacx": "This shift",
  "ops.add.working.hours.and.include.12t8ipx": "Add working hours and include",
  "ops.existing.workday.hours.and.breaks.are.1dwf7e7": "Existing workday hours and breaks are preserved.",
  "ops.add.these.hours.1whqlo0": "Add these hours",
  "ops.fix.5y3j88": "Fix",
  "ops.review.this.plan.10a65tq": "Review this plan",
  "ops.work.people.and.times.are.confirmed.1axp3gb": "Work, people and times are confirmed together.",
  "ops.close.review.tn2mth": "Close review",
  "ops.resolve.before.confirming.n71h6": "Resolve before confirming",
  "ops.work.cannot.start.until.these.are.1yzuk8m": "Work cannot start until these are resolved",
  "ops.visible.planning.gaps.132238r": "Visible planning gaps",
  "ops.this.plan.is.ready.to.confirm.ecj582": "This plan is ready to confirm.",
  "ops.explicit.workday.changes.18hple5": "Explicit workday changes",
  "ops.confirm.plan.1v4j1d6": "Confirm plan",
  "ops.apply.plan.changes.v1afav": "Apply plan changes",
  "ops.staffing.gaps.remain.visible.after.confirmation.ag4qm5": "Staffing gaps remain visible after confirmation.",
  "ops.review.every.affected.task.before.applying.1284dis": "Review every affected task before applying.",
  "ops.close.repair.preview.1tqevjo": "Close repair preview",
  "ops.facts.changed.your.proposed.times.are.1ly8knh": "Facts changed. Your proposed times are preserved.",
  "ops.required.together.14g3zte": "Required together",
  "ops.these.tasks.share.people.or.prerequisites.mjbju4": "These tasks share people or prerequisites.",
  "ops.shift.hours.people.and.work.move.zhqeuy": "Shift hours, people and work move together",
  "ops.no.feasible.placement.for.all.work.8eu5u9": "No feasible placement for all work",
  "ops.change.time.or.crew.qhx2w0": "Change time or crew",
  "ops.replace.person.1qxeci4": "Replace person",
  "ops.return.to.pool.1niutka": "Return to pool",
  "ops.actual.history.service.estimates.and.independent.1y9emq2": "Actual history, service estimates and independent workday hours stay unchanged.",
  "ops.apply.selected.repair.19ipbhh": "Apply selected repair",
  "ops.the.plan.draft.was.not.saved.18ulacr": "The plan draft was not saved.",
  "ops.current.facts.changed.refresh.the.preview.7ywi38": "Current facts changed. Refresh the preview; your edits are preserved.",
  "ops.current.facts.changed.review.the.latest.198ac2d": "Current facts changed. Review the latest facts before applying; your typed times are preserved.",
  "ops.choose.a.current.shift.participant.poxdhz": "Choose a current shift participant.",
  "ops.current.facts.changed.refresh.this.repair.mra2wk": "Current facts changed. Refresh this repair before applying.",
  "ops.end.must.be.after.start.nd0tlg": "End must be after start.",
  "ops.enter.a.positive.planned.duration.14t5h5p": "Enter a positive planned duration.",
  "ops.edit.time.14zgije": "Edit time",
  "ops.task.time.1rgqerp": "Task time",
  "ops.hours.in.this.shift.sk8hcd": "Hours in this shift",
  "ops.shift.hours.1dsmab8": "Shift hours",
  "ops.close.time.editor.7241bd": "Close time editor",
  "ops.workday.1bsrn9m": "Workday",
  "ops.end.workday.hjwrz": "End workday",
  "ops.service.estimate.3h83y2": "Service estimate",
  "ops.move.the.whole.interval.10lp3xh": "Move the whole interval",
  "ops.move.earlier.go64xc": "Move earlier",
  "ops.move.later.1mepiyu": "Move later",
  "ops.adjust.end.dgvecn": "Adjust end",
  "ops.shorten.nps9h6": "Shorten",
  "ops.extend.z41i09": "Extend",
  "ops.this.clock.time.occurs.twice.196x7jl": "This clock time occurs twice",
  "ops.choose.an.occurrence.1gwtz94": "Choose an occurrence",
  "ops.crew.634tco": "Crew",
  "ops.search.crew.1qgbc02": "Search crew",
  "ops.search.included.people.1ss155a": "Search included people",
  "ops.add.people.to.this.shift.to.10fnkj0": "Add people to this shift to fill the crew.",
  "ops.checking.vyewnp": "Checking…",
  "ops.apply.time.dasllk": "Apply time",
  "ops.planned.duration.minutes.101w497": "Planned duration (minutes)",
  "ops.a.qa.fixture.can.only.be.lg1ius": "A QA fixture can only be installed once per session.",
  "ops.apply.or.discard.pending.plan.changes.1qaba2d": "Apply or discard pending plan changes before finishing.",
  "ops.moved.with.shift.19qmtvw": "Moved with shift",
  "ops.count.unscheduledSelected.one": "{count} selected task without a time",
  "ops.count.unscheduledSelected.few": "{count} selected tasks without a time",
  "ops.count.unscheduledSelected.many": "{count} selected tasks without a time",
  "ops.count.unscheduledSelected.other": "{count} selected tasks without a time",
  "ops.count.proposedChanges.one": "{count} proposed change",
  "ops.count.proposedChanges.few": "{count} proposed changes",
  "ops.count.proposedChanges.many": "{count} proposed changes",
  "ops.count.proposedChanges.other": "{count} proposed changes",
  "ops.demo.scenario.hzmtq8": "Demo scenario",
  "ops.ordinary.operations.8ulj9n": "Ordinary operations",
  "ops.a.coherent.operational.day.with.separate.ayuhc9": "A coherent operational day with separate workload, workforce and execution history.",
  "ops.verify.two.adjacent.bookings.before.removing.14bhwvi": "Verify two adjacent bookings before removing their internal turnover.",
  "ops.staffing.gap.1sex7g7": "Staffing gap",
  "ops.a.planned.team.has.an.unfilled.wlj0ld": "A planned team has an unfilled position and unassigned crew.",
  "ops.missing.information.19lb9f9": "Missing information",
  "ops.access.is.unconfirmed.for.required.work.jkax9u": "Access is unconfirmed for required work.",
  "ops.no.eligible.workday.1g6crmu": "No eligible workday",
  "ops.a.required.service.cannot.fit.its.14uaklz": "A required service cannot fit its permitted days before the deadline.",
  "ops.split.and.overnight.hours.188n4ad": "Split and overnight hours",
  "ops.working.intervals.preserve.breaks.and.cross.1dpaq8i": "Working intervals preserve breaks and cross midnight explicitly.",
  "ops.overdue.work.1as5cwc": "Overdue work",
  "ops.an.unfinished.dated.obligation.retains.its.1ir7o74": "An unfinished dated obligation retains its missed deadline.",
  "ops.staff.absence.18qmaf6": "Staff absence",
  "ops.actual.absence.affects.an.active.commitment.48warm": "Actual absence affects an active commitment without deleting its history.",
  "ops.late.checkout.aj5gzz": "Late checkout",
  "ops.a.source.correction.changes.a.committed.1w6s201": "A source correction changes a committed service window and requires review.",
  "ops.usability.a.1t0yv7m": "Usability A",
  "ops.usability.b.1sqz9in": "Usability B",
  "ops.ten.assignments.four.available.people.same.ccimxg": "Ten assignments; four available people; same-day planning and repair.",
  "ops.spring.clock.change.2nv32q": "Spring clock change",
  "ops.edit.overnight.availability.across.the.missing.1dkn8il": "Edit overnight availability across the missing spring clock hour.",
  "ops.autumn.clock.change.7ndlpb": "Autumn clock change",
  "ops.resolve.the.repeated.autumn.clock.hour.bb27if": "Resolve the repeated autumn clock hour explicitly.",
  "ops.save.failure.and.recovery.bz7npy": "Save failure and recovery",
  "ops.the.next.save.will.fail.once.14uxpbk": "The next save will fail once. Retain edits, then retry safely.",
  "ops.import.reconciliation.9csroh": "Import reconciliation",
  "ops.resolve.duplicate.names.and.a.local.vby1ji": "Resolve duplicate names and a local hour override using the source comparison.",
  "ops.reference.scale.1ai934c": "Reference scale",
  "ops.500.units.100.people.and.10.j8p8yv": "500 units, 100 people and 10,000 assignments.",
  "ops.choose.an.available.demo.scenario.3avvy3": "Choose an available demo scenario.",
  "ops.install.qa.fixtures.before.testing.any.ezigeo": "Install QA fixtures before testing any actions.",
  "ops.qa.fixture.setup.is.unavailable.sb3zpv": "QA fixture setup is unavailable.",
  "ops.time.not.recorded.1hqvefz": "Time not recorded",
  "ops.team.not.recorded.csdikn": "Team not recorded",
  "ops.work.details.1v2ecqe": "Work details",
  "ops.a.shift.containing.actual.work.must.1wr3arj": "A shift containing actual work must retain its property, workday, and start time.",
  "ops.the.shift.must.contain.all.recorded.1vojwni": "The shift must contain all recorded work and end no earlier than the current time.",
  "ops.no.timing.changes.are.needed.dq0wwq": "No timing changes are needed.",
  "ops.pause.active.work.before.handing.it.wqhhpf": "Pause active work before handing it over. Recorded work stays intact.",
  "ops.pause.active.work.4md9dy": "Pause active work",
  "ops.edits.saved.1xohf0h": "Edits saved",
  "ops.work.and.times.1ttlbyr": "Work and times",
  "ops.people.and.participation.9miliy": "People and participation",
  "ops.recorded.in.work.history.pbcp25": "Recorded in work history",
  "ops.plan.is.confirmed.yr4w5f": "Plan is confirmed.",
  "ops.finish.the.current.time.edit.before.5dywm0": "Finish the current time edit before confirming.",
  "ops.recorded.work.fixes.the.shift.start.9gtedq": "Recorded work fixes the shift start. You can adjust its future end.",
  "ops.start.clock.occurrence.rexyhq": "Start clock occurrence",
  "ops.end.clock.occurrence.1swsg3x": "End clock occurrence",
  "ops.timeline.zoom.1jgxd0p": "Timeline zoom",
  "ops.fit.4u54gc": "Fit",
  "ops.readable.223gl1": "Readable",
  "ops.an.import.cannot.turn.unavailability.into.14e5l9m": "An import cannot turn unavailability into working time. Edit the workday explicitly.",
  "ops.agenda.1xbkjzp": "Agenda",
  "ops.unavailable.periods.and.commitments.in.other.uoq1yo": "Unavailable periods and commitments in other shifts are excluded.",
  "ops.orientation.a.katbp2": "Orientation A",
  "ops.orientation.b.k0tq03": "Orientation B",
  "ops.identify.overdue.work.a.vacant.staffing.7ra8wt": "Identify overdue work, a vacant staffing position and a changed checkout before planning.",
  "ops.for.active.shifts.capacity.and.estimated.7p6dwv": "For active shifts, capacity and estimated labor use the remaining time.",
  "ops.required.skills.are.not.covered.11q7nh3": "Required skills are not covered.",
  "ops.a.future.stay.cannot.be.confirmed.fl2z92": "A future stay cannot be confirmed checked out.",
  "ops.a.manually.registered.guest.return.cleaning.1uwel3j": "A manually registered guest-return cleaning superseded this completion.",
  "ops.a.manually.reported.guest.return.invalidated.u75nua": "A manually reported guest return invalidated the previous cleaning cycle.",
  "ops.a.new.follow.up.cleaning.will.1l7x8d": "A new follow-up cleaning will be registered.",
  "ops.a.newer.stay.has.already.arrived.16nf80c": "A newer stay has already arrived. Confirm checkout for its actual reservation cycle.",
  "ops.access.information.predates.the.latest.arrival.ciiw6i": "Access information predates the latest arrival.",
  "ops.authorize.this.early.service.window.before.1r1zy9t": "Authorize this early service window before linking its completion.",
  "ops.choose.a.cleaning.service.before.registering.zy4un5": "Choose a cleaning service before registering the follow-up.",
  "ops.choose.a.completed.cleaning.for.this.1quv37m": "Choose a completed cleaning for this unit.",
  "ops.choose.a.completed.cleaning.from.this.xepwqh": "Choose a completed cleaning from this reservation cycle.",
  "ops.choose.a.positive.whole.service.duration.1i9y0i8": "Choose a positive whole service duration.",
  "ops.choose.a.valid.early.service.window.lwz2nj": "Choose a valid early service window.",
  "ops.choose.a.valid.estimate.source.107ngt8": "Choose a valid estimate source.",
  "ops.choose.a.valid.future.practice.time.1v66u18": "Choose a valid future practice time.",
  "ops.choose.a.valid.workday.or.an.1q83tpu": "Choose a valid workday or an undated follow-up.",
  "ops.choose.an.existing.reservation.cycle.ct4krm": "Choose an existing reservation cycle.",
  "ops.choose.an.unresolved.handover.wqanrx": "Choose an unresolved handover.",
  "ops.choose.valid.work.participants.1ktlsvj": "Choose valid work participants.",
  "ops.complete.the.current.follow.up.before.zmrped": "Complete the current follow-up before reporting another guest return.",
  "ops.confirm.checkout.of.the.relevant.reservation.1tpdg48": "Confirm checkout of the relevant reservation cycle before retrying this historical update.",
  "ops.current.access.is.not.confirmed.x3s69i": "Current access is not confirmed.",
  "ops.early.service.must.begin.before.the.1kien1t": "Early service must begin before the booked departure.",
  "ops.explicit.duration.override.ffkhf9": "Explicit duration override",
  "ops.include.a.participant.before.starting.work.utahy1": "Include a participant before starting work.",
  "ops.invalid.external.roster.action.eb4iae": "Invalid external roster action.",
  "ops.invalid.operational.absence.8tu3o7": "Invalid operational absence.",
  "ops.invalid.reservation.cycle.1nxmn5i": "Invalid reservation cycle.",
  "ops.invalid.service.fulfillment.ixlqyx": "Invalid service fulfillment.",
  "ops.invalid.source.roster.snapshot.5gquiq": "Invalid source roster snapshot.",
  "ops.only.an.active.task.can.change.1fd8vjq": "Only an active task can change its current participants.",
  "ops.only.this.reservation.cycle.receives.a.rm4o8h": "Only this reservation cycle receives a confirmed checkout fact.",
  "ops.only.unchanged.source.work.hours.on.kgtqzv": "Only unchanged source work hours on represented import days may be replaced.",
  "ops.participation.changes.cannot.precede.the.active.vpdly7": "Participation changes cannot precede the active session.",
  "ops.permission.to.enter.is.not.recorded.fe68do": "Permission to enter is not recorded.",
  "ops.practice.time.can.only.advance.inside.1296m7y": "Practice time can only advance inside a practice workspace.",
  "ops.prerequisite.work.is.unfinished.tz94n9": "Prerequisite work is unfinished.",
  "ops.previous.completion.stays.in.history.readiness.mcsvye": "Previous completion stays in history; readiness and prior checkout eligibility are cleared.",
  "ops.record.a.reason.for.this.reservation.2qjtw3": "Record a reason for this reservation-cycle action.",
  "ops.service.default.61aq69": "Service default",
  "ops.source.reservation.dates.stay.unchanged.1d08xj9": "Source reservation dates stay unchanged.",
  "ops.started.work.cannot.be.replaced.by.qugwld": "Started work cannot be replaced by another completion. Review its actual history.",
  "ops.the.early.service.window.cannot.precede.x0zsey": "The early service window cannot precede the manually reported return.",
  "ops.the.existing.turnover.will.use.the.1jtnwx": "The existing turnover will use the authorized early service window.",
  "ops.the.planned.interval.is.outside.the.l6sr2d": "The planned interval is outside the rule’s allowed workdays or hours.",
  "ops.the.reservation.checkout.or.service.cycle.4z4d51": "The reservation checkout or service cycle changed after this update was queued.",
  "ops.the.reservation.cycle.changed.refresh.this.tp2pqs": "The reservation cycle changed. Refresh this preview before applying.",
  "ops.the.rule.does.not.allow.work.px1v5h": "The rule does not allow work at this local time.",
  "ops.the.selected.completed.cleaning.will.fulfill.cgsfrn": "The selected completed cleaning will fulfill this cycle without repeating work.",
  "ops.the.service.window.has.not.opened.95ufp1": "The service window has not opened.",
  "ops.the.unit.is.occupied.da44i0": "The unit is occupied.",
  "ops.this.cleaning.predates.the.selected.stay.11x7dc2": "This cleaning predates the selected stay. Choose its actual reservation cycle.",
  "ops.this.completion.already.belongs.to.another.1r04m49": "This completion already belongs to another reservation cycle.",
  "ops.this.completion.predates.the.manually.reported.4v8bya": "This completion predates the manually reported return.",
  "ops.this.person.is.already.participating.le3n3d": "This person is already participating.",
  "ops.this.person.is.not.currently.participating.1azkid8": "This person is not currently participating.",
  "ops.this.reservation.cycle.is.no.longer.edavuq": "This reservation cycle is no longer current. Review its source booking.",
  "ops.unit.cleaning.standard.12ecx3r": "Unit cleaning standard",
  "ops.use.the.reservation.cycle.action.to.1n228c7": "Use the reservation-cycle action to link work or register a guest-return follow-up.",
  "ops.work.requirements.need.review.87brci": "Work requirements need review.",
  "ops.workspace.upgrade.1t6heze": "Workspace upgrade",
  "ops.not.assigned.xhul9i": "Not assigned",
  "ops.planning.resources.72dxw9": "Planning resources",
  "ops.preview.repair.zslk3o": "Preview repair",
  "ops.duty.in.this.shift.z5v3pk": "Duty in this shift",
  "ops.no.territory.74jy9c": "No territory",
  "ops.optional.additional.work.1cspp2b": "Optional additional work",
  "ops.new.work.egh7lq": "New work",
  "ops.unit.territory.or.service.1wav5yb": "Unit, territory or service",
  "ops.this.day.ov27y7": "This day",
  "ops.carryover.1astm2i": "Carryover",
  "ops.additional.work.jxxom9": "Additional work",
  "ops.all.territories.1aua5tm": "All territories",
  "ops.work.access.dlf9jm": "Work access",
  "ops.all.access.g2rb52": "All access",
  "ops.available.now.pi5gsw": "Available now",
  "ops.additional.work.at.these.units.qcug6": "Additional work at these units",
  "ops.no.work.matches.this.view.change.ejbvmn": "No work matches this view. Change filters or add new work.",
  "ops.add.workday.hours.a2haxm": "Add workday hours",
  "ops.carryover.work.added.to.this.shift.17lx48e": "Carryover work added to this shift",
  "ops.access.unknown.rcrpm5": "Access unknown",
  "ops.participation.jbcgo6": "Participation",
  "ops.elapsed.work.7do8fw": "Elapsed work",
  "ops.person.minutes.1ui49vw": "Person-minutes",
  "ops.planned.crew.1mk6mpy": "Planned crew",
  "ops.working.now.1erfkxs": "Working now",
  "ops.left.task.y60j8l": "Left task",
  "ops.record.departure.rual8w": "Record departure",
  "ops.join.active.task.1oec3t2": "Join active task",
  "ops.join.task.1kp3yui": "Join task",
  "ops.departure.is.always.recorded.work.pauses.1lg9s2l": "Departure is always recorded. Work pauses if the remaining crew no longer meets its requirements.",
  "ops.work.source.43s4dh": "Work source",
  "ops.all.work.11fsgah": "All work",
  "ops.estimate.source.1kkf0so": "Estimate source",
  "ops.historical.approval.reference.2fsi8d": "Historical approval reference",
  "ops.authorize.early.cleaning.127fjd6": "Authorize early cleaning",
  "ops.confirm.actual.checkout.1l124ep": "Confirm actual checkout",
  "ops.link.completed.cleaning.85m6kr": "Link completed cleaning",
  "ops.guest.returned.add.follow.up.cleaning.1ubwv8z": "Guest returned — add follow-up cleaning",
  "ops.choose.a.stay.cycle.and.action.s9jwfn": "Choose a stay cycle and action.",
  "ops.add.a.reason.for.this.operational.1xnjk": "Add a reason for this operational change.",
  "ops.stay.and.cleaning.cycle.b10n5i": "Stay and cleaning cycle",
  "ops.checkout.confirmed.tzf5ck": "Checkout confirmed",
  "ops.checkout.unconfirmed.1hvq1ph": "Checkout unconfirmed",
  "ops.stay.cycle.uhyo8u": "Stay cycle",
  "ops.early.service.authorized.1h8ekvw": "Early service authorized",
  "ops.actual.checkout.1tk6lu1": "Actual checkout",
  "ops.guest.ready.completion.1bqaycd": "Guest-ready completion",
  "ops.cleaning.completed.1615n57": "Cleaning completed",
  "ops.previous.service.cycle.bu63xh": "Previous service cycle",
  "ops.cleaning.vacancy.and.confirmed.checkout.are.1nm3lme": "Cleaning, vacancy and confirmed checkout are separate facts. Original booking dates stay unchanged.",
  "ops.authorized.from.1cotnwc": "Authorized from",
  "ops.authorized.until.optional.sg9e3f": "Authorized until (optional)",
  "ops.completed.cleaning.1mw4oud": "Completed cleaning",
  "ops.choose.completed.work.1ce6v2e": "Choose completed work",
  "ops.follow.up.workday.optional.19vuh02": "Follow-up workday (optional)",
  "ops.review.consequences.1psdc9x": "Review consequences",
  "ops.current.facts.changed.preview.the.impact.10zbrte": "Current facts changed. Preview the impact again.",
  "ops.service.cycle.hit1ki": "Service cycle",
  "ops.until.rg2a5r": "Until",
  "ops.recorded.by.qy4q42": "Recorded by",
  "ops.recorded.at.ncd1le": "Recorded at",
  "ops.deadline.ht2sph": "Deadline",
  "ops.value.1m2g8kq": "Value",
  "ops.current.1dw4k8q": "Current",
  "ops.confirmed.checkout.1tv8b0u": "Confirmed checkout",
  "ops.yes.1dudzcg": "Yes",
  "ops.varies.by.unit.standard.iek8kx": "Varies by unit standard",
  "ops.each.unit.s.cleaning.standard.is.wzd5hl": "Each unit's cleaning standard is used. Preview shows the resolved work.",
  "ops.default.estimate.source.169ydnd": "Default estimate source",
  "ops.service.default.minutes.1096h2h": "Service default (minutes)",
  "ops.external.roster.corrections.2kjpoo": "External roster corrections",
  "ops.compare.luuta.workday.hours.with.the.fcce9n": "Compare Luuta workday hours with the last accepted source roster.",
  "ops.review.corrections.jo5xmw": "Review corrections",
  "ops.could.not.preserve.the.unsaved.form.wame2s": "Could not preserve the unsaved form. Export your recovery draft before leaving.",
  "ops.wait.for.the.current.save.to.18lymb6": "Wait for the current save to finish. Your edits are preserved.",
  "ops.recovered.unsaved.edits.review.current.facts.5k3mw0": "Recovered unsaved edits. Review current facts before saving.",
  "ops.plan.early.cleaning.1jhopb0": "Plan early cleaning",
  "ops.user.guide.1k66u1q": "User guide",
  "ops.practice.with.real.controls.in.a.6zxqc7": "Practice with real controls in a separate workspace. Your operational records stay where they are.",
  "ops.practice.the.full.process.1wfgtid": "Practice the full process",
  "ops.choose.work.build.a.team.handle.1jwylw8": "Choose work, build a team, handle changes, execute tasks and carry unfinished work forward.",
  "ops.opening.practice.g7id1u": "Opening practice…",
  "ops.start.full.practice.1v8dmth": "Start full practice",
  "ops.resume.practice.92ni3f": "Resume practice",
  "ops.completed.steps.bxss45": "Completed steps",
  "ops.practice.one.chapter.1u3f1ux": "Practice one chapter",
  "ops.starting.a.chapter.creates.its.own.1untv4a": "Starting a chapter creates its own practice scenario. No operational workspace is reset.",
  "ops.this.guide.teaches.the.product.it.15gm8d2": "This guide teaches the product. It is separate from the untrained usability study.",
  "ops.interactive.practice.guide.ui8vfo": "Interactive practice guide",
  "ops.practice.1tlbcsw": "Practice",
  "ops.resume.guide.3i6qfa": "Resume guide",
  "ops.pause.guide.134n8r9": "Pause guide",
  "ops.exit.practice.1xyccmu": "Exit practice",
  "ops.guide.paused.your.practice.work.is.h64d3b": "Guide paused. Your practice work is saved separately.",
  "ops.chapter.completed.apheln": "Chapter completed",
  "ops.continue.the.full.process.flgtxd": "Continue the full process",
  "ops.return.to.operations.e5d8ka": "Return to operations",
  "ops.restart.chapter.16r91f5": "Restart chapter",
  "ops.advance.practice.time.frm80b": "Advance practice time",
  "ops.download.practice.xlsx.ckzoox": "Download practice XLSX",
  "ops.make.next.practice.save.fail.6qzxia": "Make next practice save fail",
  "ops.reload.practice.edox8t": "Reload practice",
  "ops.show.me.where.z0vpl1": "Show me where",
  "ops.previous.guide.step.dql4tu": "Previous guide step",
  "ops.complete.the.highlighted.action.to.continue.130wqbs": "Complete the highlighted action to continue. Your real records are unaffected.",
  "ops.only.this.practice.run.can.be.121s9fz": "Only this practice run can be reset or restored here. Your operational workspace is unchanged.",
  "ops.save.practice.checkpoint.1syya4h": "Save practice checkpoint",
  "ops.restart.practice.chapter.21outs": "Restart practice chapter",
  "ops.practice.checkpoint.1axc6f2": "Practice checkpoint",
  "ops.before.planning.gap.upgrade.1645acj": "Before planning gap upgrade",
  "ops.practice.checkpoint.restored.as.a.separate.10n4r75": "Practice checkpoint restored as a separate workspace.",
  "ops.practice.workspace.12emsx9": "Practice workspace",
  "ops.synthetic.exercises.using.the.real.operations.w6ojkb": "Synthetic exercises using the real operations workflow.",
  "ops.prepare.a.day.y5362d": "Prepare a day",
  "ops.read.demand.find.additional.work.and.15ouha6": "Read demand, find additional work and choose what belongs in this shift.",
  "ops.choose.the.day.k1qcft": "Choose the day",
  "ops.check.the.property.workday.and.shift.1q5telo": "Check the property, workday and shift hours. These define this plan, not everybody’s workday.",
  "ops.register.additional.work.1q19rr6": "Register additional work",
  "ops.create.terrace.cleaning.for.village.2.126y7mv": "Create Terrace cleaning for Village 2. Leave its workday and deadline empty; save it for later.",
  "ops.read.one.territory.r49kzj": "Read one territory",
  "ops.open.work.and.filter.lakeside.compare.rl03pg": "Open Work and filter Lakeside. Compare required work with houses available now; then clear the filter.",
  "ops.choose.the.first.houses.ggi5by": "Choose the first houses",
  "ops.add.turnover.cleaning.for.lake.1.l3auh4": "Add Turnover cleaning for Lake 1 and Lake 2 to the shift. Opening Work alone adds nothing.",
  "ops.include.an.independent.extra.1d4jj2m": "Include an independent extra",
  "ops.open.additional.work.and.add.window.18xphjf": "Open Additional work and add Window cleaning for Lake 1. A suggestion is not selected automatically.",
  "ops.check.the.staffing.need.k440ne": "Check the staffing need",
  "ops.read.work.productive.capacity.skills.and.1eiqi4a": "Read work, productive capacity, skills and gaps. Additional work has its own duration and completion.",
  "ops.build.and.confirm.1xns3nq": "Build and confirm",
  "ops.choose.people.duties.and.hours.arrange.82p73q": "Choose people, duties and hours; arrange first houses and confirm.",
  "ops.add.the.first.person.ukuyc6": "Add the first person",
  "ops.open.people.and.add.aino.korhonen.nlmdd7": "Open People and add Aino Korhonen using her existing workday hours.",
  "ops.add.a.second.person.mcoa6i": "Add a second person",
  "ops.add.leo.m.kel.you.may.1pk0bod": "Add Leo Mäkelä. You may leave later houses unscheduled when confirming the plan.",
  "ops.include.someone.without.workday.hours.107ghw5": "Include someone without workday hours",
  "ops.add.mila.virtanen.set.09.30.1rda1h6": "Add Mila Virtanen. Set 09:30–16:00, then use Add working hours and include.",
  "ops.choose.today.s.duty.ltfx4v": "Choose today’s duty",
  "ops.set.aino.s.duty.to.cleaner.a5va2t": "Set Aino’s duty to Cleaner. This changes her responsibility in this shift, not her profile skills.",
  "ops.adjust.participation.hours.1ef8cqs": "Adjust participation hours",
  "ops.open.aino.s.hours.change.end.1dql472": "Open Aino’s hours, change End to 15:30 and apply. Her available workday still ends at 16:00.",
  "ops.arrange.the.first.task.nman9f": "Arrange the first task",
  "ops.open.lake.1.s.time.choose.1xbg7nt": "Open Lake 1’s time. Choose Aino, set 09:30–10:30 and Apply time. Keep the service estimate unchanged.",
  "ops.review.one.clear.plan.1w6oliv": "Review one clear plan",
  "ops.open.review.confirm.check.work.people.n3ij7i": "Open Review & confirm. Check work, people, hours and visible gaps before committing.",
  "ops.confirm.the.plan.13jcken": "Confirm the plan",
  "ops.choose.confirm.plan.the.work.and.j0gbf9": "Choose Confirm plan. The work and calendar changes are committed together; unscheduled later work stays visible.",
  "ops.handle.changes.1lviff2": "Handle changes",
  "ops.record.absence.and.late.checkout.then.v42k74": "Record absence and late checkout, then review a safe repair.",
  "ops.record.an.explained.absence.s7bxmq": "Record an explained absence",
  "ops.in.aino.s.workday.record.sickness.124p2kw": "In Aino’s workday, record sickness from 09:30 to 16:00. Keep when it was reported separate from when it applies.",
  "ops.correct.a.late.checkout.1sviqda": "Correct a late checkout",
  "ops.edit.the.current.lake.1.booking.19cz0p7": "Edit the current Lake 1 booking: change departure to 11:00 today and review/save its impact.",
  "ops.review.the.affected.work.iql2j7": "Review the affected work",
  "ops.open.preview.repair.check.the.absent.enpypq": "Open Preview repair. Check the absent person and late checkout; use an available replacement and apply the reviewed changes.",
  "ops.find.the.external.correction.1qokbdw": "Find the external correction",
  "ops.open.external.roster.corrections.this.compares.cebfn4": "Open External roster corrections. This compares workday availability with the last imported source, not task placements.",
  "ops.execute.and.hand.over.i7ua04": "Execute and hand over",
  "ops.record.real.participation.finish.independent.work.myi48j": "Record real participation, finish independent work and carry the rest forward.",
  "ops.confirm.who.is.on.site.70mb1": "Confirm who is on site",
  "ops.open.people.and.mark.leo.and.skbhlb": "Open People and mark Leo and Mila present. A planned workday is not attendance.",
  "ops.start.the.shift.10u9kqw": "Start the shift",
  "ops.choose.start.shift.individual.tasks.still.1k2mq73": "Choose Start shift. Individual tasks still check access, attendance, skills and crew before starting.",
  "ops.move.practice.time.to.the.task.f1uw8p": "Move practice time to the task",
  "ops.advance.the.practice.clock.to.the.1o7twm7": "Advance the practice clock to the first task’s start. Only practice time changes.",
  "ops.start.lake.1.cleaning.s24r7c": "Start Lake 1 cleaning",
  "ops.open.the.assignment.and.start.work.pyg42s": "Open the assignment and Start work. Actual participation is now recorded separately from the plan.",
  "ops.add.actual.help.1dwp75": "Add actual help",
  "ops.use.join.and.choose.mila.this.uc6x59": "Use Join and choose Mila. This records who actually joined; it does not rewrite the planned crew.",
  "ops.record.twenty.minutes.of.help.1rofk0w": "Record twenty minutes of help",
  "ops.advance.practice.time.both.people.s.11wnv95": "Advance practice time. Both people’s recorded participation remains in the history.",
  "ops.let.one.person.continue.1snedvw": "Let one person continue",
  "ops.use.leave.and.choose.leo.mila.1np3bg8": "Use Leave and choose Leo. Mila should continue without a false pause. Required crews would pause if left unsafe.",
  "ops.finish.the.recorded.interval.n5839c": "Finish the recorded interval",
  "ops.advance.practice.time.to.sixty.minutes.jwyp6h": "Advance practice time to sixty minutes after the task started.",
  "ops.complete.cleaning.independently.ah3thc": "Complete cleaning independently",
  "ops.complete.lake.1.cleaning.its.window.80tyu8": "Complete Lake 1 cleaning. Its window-cleaning assignment remains unfinished.",
  "ops.arrange.the.extra.separately.iaxh4s": "Arrange the extra separately",
  "ops.set.window.cleaning.to.12.00.w4rvn0": "Set Window cleaning to 12:00–12:30 with Mila. Review and apply the plan changes.",
  "ops.start.the.extra.only.service.ll0vuc": "Start the extra-only service",
  "ops.start.window.cleaning.for.lake.1.71k2bf": "Start Window cleaning for Lake 1. Cleaning already completed; this service has its own actual session.",
  "ops.record.the.extra.s.time.1e9gxoi": "Record the extra’s time",
  "ops.advance.practice.time.by.thirty.minutes.1x5hmua": "Advance practice time by thirty minutes from the extra’s actual start.",
  "ops.complete.the.extra.1ujayij": "Complete the extra",
  "ops.complete.window.cleaning.its.result.stays.18sg8rl": "Complete Window cleaning. Its result stays separate from the earlier cleaning.",
  "ops.finish.with.a.clear.handover.kl7onn": "Finish with a clear handover",
  "ops.finish.shift.return.unfinished.lake.2.yp87t6": "Finish shift. Return unfinished Lake 2 work to the pool, keep Dispatcher as owner, and confirm closure.",
  "ops.look.at.the.next.day.wek7mr": "Look at the next day",
  "ops.advance.practice.time.to.tomorrow.original.1ddgqdm": "Advance practice time to tomorrow. Original deadlines and recorded work remain unchanged.",
  "ops.find.unfinished.obligations.nze2ua": "Find unfinished obligations",
  "ops.open.carryover.for.the.next.day.vzorkr": "Open Carryover for the next day. Read the original workday, deadline and recorded Dispatcher owner.",
  "ops.units.and.work.rules.wtay4x": "Units and work rules",
  "ops.inspect.inherited.rules.save.a.local.6bqpys": "Inspect inherited rules, save a local draft and preview its demand.",
  "ops.inspect.effective.rules.zmfn7t": "Inspect effective rules",
  "ops.open.lake.1.and.its.work.l375eh": "Open Lake 1 and its work rules. Inherited and local rules appear together with their origins.",
  "ops.create.a.local.rule.draft.1vxsdna": "Create a local rule draft",
  "ops.create.a.unit.rule.for.lake.17jrhko": "Create a unit rule for Lake 1: Window cleaning after checkout. Name it Practice windows and save a draft.",
  "ops.preview.and.activate.1hwnfwz": "Preview and activate",
  "ops.open.the.draft.preview.its.six.1pf5quh": "Open the draft, preview its six-week demand and impacts, then activate. Verify the work keeps its rule provenance.",
  "ops.bookings.and.early.cleaning.uwbsba": "Bookings and early cleaning",
  "ops.link.continuous.stays.record.early.fulfillment.xwkg84": "Link continuous stays, record early fulfillment and add a manual return cleaning.",
  "ops.link.a.verified.continuous.stay.5s2ga2": "Link a verified continuous stay",
  "ops.select.both.village.3.booking.segments.enx5cn": "Select both Village 3 booking segments. Review continuity, verify the shared guest reference, and link the stay.",
  "ops.plan.early.cleaning.manually.62og8p": "Plan early cleaning manually",
  "ops.open.village.2.use.plan.early.ytjtmc": "Open Village 2. Use Plan early cleaning for today, without changing the booked departure tomorrow.",
  "ops.link.recorded.cleaning.explicitly.1q2eni1": "Link recorded cleaning explicitly",
  "ops.link.the.completed.practice.cleaning.to.11m0dy7": "Link the completed practice cleaning to this turnover. Review the exact stay and work before applying.",
  "ops.confirm.checkout.separately.ak315x": "Confirm checkout separately",
  "ops.inspect.the.held.sync.condition.then.xcga9e": "Inspect the held sync condition, then explicitly confirm Village 2 checkout. Vacancy alone must not confirm it.",
  "ops.add.a.return.cleaning.manually.10f77lz": "Add a return cleaning manually",
  "ops.choose.guest.returned.add.follow.up.qn7hz8": "Choose Guest returned → Add follow-up cleaning. Verify new work, cleared readiness and preserved original completion.",
  "ops.quinyx.and.external.corrections.gsbv5u": "Quinyx and external corrections",
  "ops.import.a.real.practice.file.and.11ufgsd": "Import a real practice file and reconcile local hours with the source.",
  "ops.download.a.practice.roster.1ww8jki": "Download a practice roster",
  "ops.download.the.synthetic.xlsx.it.uses.18fuwvz": "Download the synthetic XLSX. It uses the same employee IDs and date as this practice workspace.",
  "ops.import.through.the.real.reader.swhpgt": "Import through the real reader",
  "ops.upload.the.practice.xlsx.review.identities.hicg4d": "Upload the practice XLSX. Review identities and hours; keep Aino’s local 15:00 end and apply.",
  "ops.record.an.external.action.1wp699s": "Record an external action",
  "ops.open.external.roster.corrections.mark.aino.1764cux": "Open External roster corrections. Mark Aino’s change updated externally; it stays awaiting source confirmation.",
  "ops.download.the.corrected.source.108smxq": "Download the corrected source",
  "ops.download.the.newer.practice.roster.with.nby963": "Download the newer practice roster with Aino ending at 15:00, then upload it as a newer complete source.",
  "ops.check.source.confirmation.1uor74l": "Check source confirmation",
  "ops.verify.the.correction.history.distinguishes.your.1wcvrbl": "Verify the correction history distinguishes your external-update claim from confirmation by the newer source.",
  "ops.recover.safely.wgq1bn": "Recover safely",
  "ops.keep.edits.through.a.failed.save.15e1tuf": "Keep edits through a failed save, reload and practice-only restoration.",
  "ops.practice.a.failed.save.bav291": "Practice a failed save",
  "ops.arm.one.practice.only.save.failure.h0sybf": "Arm one practice-only save failure. Operational saves are unaffected.",
  "ops.keep.and.retry.your.edits.1sfx62f": "Keep and retry your edits",
  "ops.edit.the.shift.end.time.after.10tv3wi": "Edit the shift end time. After the failed save, retain the input and retry until the change is saved.",
  "ops.resume.after.reload.1azwjkx": "Resume after reload",
  "ops.reload.this.page.your.practice.workspace.us2ilx": "Reload this page. Your practice workspace, step and saved edits should remain available.",
  "ops.save.a.practice.checkpoint.4it4ya": "Save a practice checkpoint",
  "ops.open.recovery.tools.and.save.a.wl1isp": "Open recovery tools and save a practice checkpoint. Only this practice run’s backups are listed.",
  "ops.restore.a.practice.copy.1ucelfg": "Restore a practice copy",
  "ops.restore.the.practice.checkpoint.as.a.ner6o0": "Restore the practice checkpoint as a copy. The original operational workspace must remain untouched.",
  "ops.choose.mila.under.join.active.task.1ouxune": "Choose Mila under Join active task, then Join task. This records actual help without rewriting the planned crew.",
  "ops.for.leo.choose.record.departure.mila.17b2api": "For Leo, choose Record departure. Mila continues without a false pause. Required crews pause if left unsafe.",
  "ops.open.village.2.use.plan.early.hqyy2o": "Open Village 2. Use Plan early cleaning for 08:00–10:00 today, without changing the booked departure tomorrow.",
  "ops.this.backup.belongs.to.another.workspace.9udp73": "This backup belongs to another workspace context.",
  "ops.practice.progress.is.unavailable.14ejjmr": "Practice progress is unavailable.",
  "ops.practice.progress.targets.another.workspace.1dpsxo7": "Practice progress targets another workspace.",
  "ops.practice.progress.changed.in.another.tab.8bxpnf": "Practice progress changed in another tab. Reload to continue.",
  "ops.invalid.practice.progress.w2s172": "Invalid practice progress.",
  "ops.choose.a.practice.chapter.ah7d1": "Choose a practice chapter.",
  "ops.the.original.workspace.is.unavailable.choose.kruh88": "The original workspace is unavailable. Choose another workspace before practicing.",
  "ops.practice.recovery.is.available.only.in.11nlray": "Practice recovery is available only in a practice workspace.",
  "ops.choose.a.local.return.page.gdsx2p": "Choose a local return page.",
  "ops.this.practice.version.has.changed.start.1mwi05j": "This practice version has changed. Start a new run from User guide.",
  "ops.practice.is.unavailable.in.this.repository.sr7a0l": "Practice is unavailable in this repository.",
  "ops.practice.recovery.is.unavailable.1z6hsf": "Practice recovery is unavailable.",
  "ops.practice.could.not.resume.your.operations.ts2ui4": "Practice could not resume. Your operations workspace is unchanged.",
  "ops.download.correction.checklist.1nt1qtf": "Download correction checklist",
  "ops.this.is.a.manual.correction.checklist.1pmjaz8": "This is a manual correction checklist, not a Quinyx upload file. Recording an external update does not verify it; a later covering source file must confirm the result.",
  "ops.last.accepted.source.1nd7lxj": "Last accepted source",
  "ops.represented.employee.days.only.uaczvs": "Represented employee-days only",
  "ops.source.version.7g9z78": "Source version",
  "ops.accepted.i9emhs": "Accepted",
  "ops.no.source.roster.yet.1465h28": "No source roster yet",
  "ops.import.a.roster.to.establish.verified.153f6ze": "Import a roster to establish verified comparison coverage. Existing local hours are preserved.",
  "ops.current.differences.29btje": "Current differences",
  "ops.awaiting.source.confirmation.1bx91w1": "Awaiting source confirmation",
  "ops.search.roster.differences.1ligf1k": "Search roster differences",
  "ops.person.employee.id.or.date.17qjmwa": "Person, employee ID or date",
  "ops.no.external.employee.id.bzta0w": "No external employee ID",
  "ops.external.action.needed.1peduf5": "External action needed",
  "ops.last.source.roster.yqi05h": "Last source roster",
  "ops.current.luuta.hours.1nkp3sw": "Current Luuta hours",
  "ops.add.working.hours.externally.ikx02s": "Add working hours externally",
  "ops.remove.working.hours.externally.zpb30n": "Remove working hours externally",
  "ops.update.working.hours.externally.1wtj2g4": "Update working hours externally",
  "ops.record.absence.externally.82l83p": "Record absence externally",
  "ops.record.external.update.bp8hug": "Record external update",
  "ops.no.matching.differences.1xbcd6l": "No matching differences",
  "ops.no.current.roster.differences.3ah12q": "No current roster differences",
  "ops.try.another.person.or.date.1qof835": "Try another person or date.",
  "ops.luuta.matches.the.known.source.coverage.mtm4hi": "Luuta matches the known source coverage. Dates outside that coverage remain unverified.",
  "ops.external.update.history.u70ngf": "External update history",
  "ops.confirmed.by.source.zr6xbo": "Confirmed by source",
  "ops.new.source.does.not.confirm.update.nrxr23": "New source does not confirm update",
  "ops.the.current.difference.remains.visible.until.1e8ms6t": "The current difference remains visible until a later source confirms it.",
  "ops.use.this.after.making.the.correction.6skdlg": "Use this after making the correction outside Luuta. It records your action without claiming that Quinyx has been checked.",
  "ops.no.working.hours.1bcohpq": "No working hours",
  "ops.optional.note.gg1lqz": "Optional note",
  "ops.absences.1i1sir5": "Absences",
  "ops.record.absence.fbj62b": "Record absence",
  "ops.sickness.1fe8g48": "Sickness",
  "ops.unpaid.leave.1ldj78n": "Unpaid leave",
  "ops.no.show.974b0": "No-show",
  "ops.other.reason.18g4fuj": "Other reason",
  "ops.reason.not.specified.syum52": "Reason not specified",
  "ops.effective.absence.starts.1ce2gu6": "Effective absence starts",
  "ops.effective.absence.ends.yjkhk1": "Effective absence ends",
  "ops.reported.at.1sd6rkr": "Reported at",
  "ops.reported.keca16": "Reported",
  "ops.operational.reason.16ih4t9": "Operational reason",
  "ops.optional.operational.note.suxjqn": "Optional operational note",
  "ops.do.not.include.medical.details.e6gh4a": "Do not include medical details.",
  "ops.saving.marks.this.interval.unavailable.and.zmro62": "Saving marks this interval unavailable and flags affected shifts. Existing work history and the uploaded source roster remain unchanged.",
  "ops.clock.occurrence.srr16u": "Clock occurrence",
  "ops.choose.clock.occurrence.1f0iv8b": "Choose clock occurrence",
  "ops.requires.a.buddy.while.working.105zo5s": "Requires a buddy while working",
  "ops.an.optional.operational.restriction.assignment.crew.1rysg5m": "An optional operational restriction. Assignment crew requirements still apply to everyone.",
  "ops.marking.present.does.not.erase.an.1itrdxn": "Marking present does not erase an absence or restore workday hours. Edit the workday explicitly when availability changes.",
  "ops.local.interval.structure.and.unavailability.are.16us34j": "Local interval structure and unavailability are preserved. Edit the workday explicitly to change them.",
  "ops.the.source.roster.has.invalid.coverage.1ki3wu3": "The source roster has invalid coverage.",
  "ops.complete.source.coverage.must.include.every.ioc9ix": "Complete source coverage must include every declared date.",
  "ops.the.source.roster.timezone.is.invalid.azi6m4": "The source roster timezone is invalid.",
  "ops.the.source.roster.contains.an.invalid.y6ekt4": "The source roster contains an invalid employee interval.",
  "ops.the.source.snapshot.identity.was.reused.hf5iie": "The source snapshot identity was reused for another file.",
  "ops.this.source.roster.is.older.than.1xhm04h": "This source roster is older than the accepted source coverage.",
  "ops.the.roster.difference.changed.review.the.1u93whu": "The roster difference changed. Review the current comparison before recording an external update.",
  "ops.choose.an.existing.person.for.this.1g3pjud": "Choose an existing person for this absence.",
  "ops.choose.a.valid.effective.absence.interval.ixm6ex": "Choose a valid effective absence interval and reported time.",
  "ops.choose.an.operational.absence.reason.v1ge56": "Choose an operational absence reason.",
  "ops.choose.a.valid.practice.roster.date.y4cb6f": "Choose a valid practice roster date.",
  "ops.known.source.intervals.1g3csuj": "Known source intervals",
  "ops.merge.files.add.source.evidence.without.9t2368": "Merge files add source evidence without proving removals. A complete covering snapshot is needed to confirm an external correction.",
  "ops.choose.valid.practice.roster.hours.qf26j1": "Choose valid practice roster hours.",
  "ops.this.workday.changed.while.you.were.nt3ki4": "This workday changed while you were editing. Close and reopen it to review current hours before saving.",
  "ops.locally.removed.source.hours.stay.removed.kqbbub": "Locally removed source hours stay removed unless you explicitly restore the source workday.",
  "ops.restore.source.workday.p9xtmr": "Restore source workday",
  "ops.record.an.absence.period.no.longer.qpp6x5": "Record an absence period no longer than one year.",
  "ops.choose.an.existing.absence.xa31ef": "Choose an existing absence.",
  "ops.choose.an.end.within.the.recorded.1evzfqk": "Choose an end within the recorded absence interval.",
  "ops.ending.an.absence.does.not.restore.1kid378": "Ending an absence does not restore working hours. Review the workday before adding hours back.",
  "ops.cancel.absence.snrgn8": "Cancel absence",
  "ops.end.absence.now.ykjsv1": "End absence now",
  "ops.no.r5wqai": "No",
  "ops.open.preview.repair.use.leo.for.1ktdxe9": "Open Preview repair. Use Leo for Lake 1 after the 11:00 checkout, then apply the reviewed changes.",
  "ops.choose.whether.this.person.requires.a.y7kjfz": "Choose whether this person requires a buddy.",
  "ops.choose.a.valid.effective.buddy.restriction.85fwym": "Choose a valid effective buddy-restriction interval.",
  "ops.buddy.requirement.starts.24l59t": "Buddy requirement starts",
  "ops.buddy.requirement.ends.optional.1gzl73h": "Buddy requirement ends (optional)",
  "ops.empty.end.means.no.scheduled.end.1fytxf8": "Empty end means no scheduled end.",
  "ops.no.scheduled.end.107usck": "No scheduled end",
  "ops.future.buddy.requirement.ltxwop": "Future buddy requirement",
  "ops.buddy.requirement.ended.186k8bk": "Buddy requirement ended",
  "ops.overdue.1qrzhgr": "Overdue",
  "ops.linen.delivered.7vrpuz": "Linen delivered",
  "ops.linen.collected.umeqec": "Linen collected",
  "ops.linen.return.checked.1bzyk4y": "Linen return checked",
  "ops.confirm.access.at.the.task.time.12m5abh": "Confirm access at the task time",
  "ops.check.lake.1.is.actually.vacant.plvki7": "Check Lake 1 is actually vacant. Edit the unit, confirm Current access as Vacant, and save. A booking’s departure time alone does not prove vacancy.",
  "ops.confirm.current.access.now.rm9zxk": "Confirm current access now",
  "ops.check.lake.1.is.actually.vacant.1y1a178": "Check Lake 1 is actually vacant. Edit the unit, choose Vacant, check Confirm current access now, and save. A booking’s departure time alone does not prove vacancy.",
  "ops.this.practice.scenario.has.changed.go.qq357w": "This practice scenario has changed. Go back or restart this chapter to restore its prerequisites.",
  "ops.selected.stay.1hmlsp1": "Selected stay",
  "ops.current.commitment.ihh35r": "Current commitment",
  "ops.current.recorded.history.13zcbt2": "Current recorded history",
  "ops.recorded.completion.actual.work.and.linen.1g5b5vr": "Recorded completion, actual work and linen history stay unchanged.",
  "ops.proposed.authorized.window.1chy95g": "Proposed authorized window",
  "ops.proposed.follow.up.cleaning.1qmczoh": "Proposed follow-up cleaning",
  "ops.proposed.fulfillment.link.25xd8b": "Proposed fulfillment link",
  "ops.proposed.checkout.confirmation.1q097nu": "Proposed checkout confirmation",
  "ops.no.end.specified.s7grw5": "No end specified",
  "ops.this.authorizes.early.service.review.any.wieuqq": "This authorizes early service. Review any changes to committed planning separately.",
  "ops.unknown.verify.before.starting.1dezmpz": "Unknown — verify before starting",
  "ops.this.recorded.cleaning.fulfills.the.selected.xiohnx": "This recorded cleaning fulfills the selected stay; a duplicate cleaning is not added.",
  "ops.unconfirmed.126zmar": "Unconfirmed",
  "ops.manually.recorded.yehjrc": "Manually recorded",
  "ops.recorded.execution.1u7bpm7": "Recorded execution",
  "ops.historical.record.fhjuiy": "Historical record",
  "ops.unspecified.1qo770": "Unspecified",
  "ops.historical.estimate.source.unrecorded.1atv3vu": "Historical estimate (source unrecorded)",
  "ops.this.completed.cleaning.has.no.recorded.1my879h": "This completed cleaning has no recorded completion time. Review its history before linking it.",
  "ops.the.completion.time.is.unrecorded.review.1uvbqjv": "The completion time is unrecorded. Review the historical work before synchronizing it.",
  "ops.planning.data.upgraded.original.records.preserved.orw8om": "Planning data upgraded; original records preserved in a backup.",
  "ops.time.1q4eyv8": "Time",
  "ops.complete.this.action.to.continue.iokmsc": "Complete this action to continue.",
  "ops.no.workday.selected.1tpu3cc": "No workday selected",
  "ops.choose.workday.c4scdh": "Choose workday",
  "ops.clear.workday.bjiq9j": "Clear workday",
  "ops.choose.scheduled.end.11seogm": "Choose scheduled end",
  "ops.clear.scheduled.end.niyhx8": "Clear scheduled end",
  "ops.this.page.could.not.load.use.zaw2": "This page could not load. Use Reload current page to continue.",
  "ops.this.view.could.not.be.loaded.uw87ki": "This view could not be loaded.",
  "ops.your.saved.workspace.and.practice.progress.wy37e7": "Your saved workspace and practice progress are unchanged. Reload this page to open the current version.",
  "ops.reload.current.page.6wcxpk": "Reload current page",
  "ops.export.saved.workspace.19xwuit": "Export saved workspace"
}

export const operationMessageIds: Record<string, string> = {
  ...Object.fromEntries(Object.entries(operationMessages).map(([id, source]) => [source, id])),
  ...{
  "active": "ops.status.active",
  "weeks": "ops.status.weeks",
  "vacant": "ops.status.vacant",
  "occupied": "ops.status.occupied",
  "unknown": "ops.status.unknown",
  "dirty": "ops.status.dirty",
  "cleaned": "ops.status.cleaned",
  "inspection-needed": "ops.status.inspection-needed",
  "ready": "ops.status.ready",
  "open": "ops.status.open",
  "in-progress": "ops.status.in-progress",
  "paused": "ops.status.paused",
  "completed": "ops.status.completed",
  "declined": "ops.status.declined",
  "cancelled": "ops.status.cancelled",
  "pending": "ops.status.pending",
  "satisfied": "ops.status.satisfied",
  "suppressed": "ops.status.suppressed",
  "superseded": "ops.status.superseded",
  "needs-information": "ops.status.needs-information",
  "needs-scheduling": "ops.status.needs-scheduling",
  "draft": "ops.status.draft",
  "retired": "ops.status.retired",
  "property": "ops.status.property",
  "unit": "ops.status.unit",
  "committed": "ops.status.committed",
  "released": "ops.status.released",
  "finished": "ops.status.finished",
  "expected": "ops.status.expected",
  "confirmed": "ops.status.confirmed",
  "present": "ops.status.present",
  "absent": "ops.status.absent",
  "eligible": "ops.status.eligible",
  "held": "ops.status.held",
  "failed": "ops.status.failed",
  "stale": "ops.status.stale",
  "simulated": "ops.status.simulated",
  "manual": "ops.status.manual",
  "rule": "ops.status.rule",
  "inspection": "ops.status.inspection",
  "rework": "ops.status.rework",
  "cleaning": "ops.status.cleaning",
  "extra": "ops.status.extra",
  "other": "ops.status.other",
  "all": "ops.status.all",
  "any": "ops.status.any",
  "days": "ops.status.days",
  "months": "ops.status.months",
  "normal": "ops.status.normal",
  "high": "ops.status.high",
  "applied": "ops.status.applied",
  "kept": "ops.status.kept",
  "warning": "ops.status.warning",
  "blocker": "ops.status.blocker",
  "info": "ops.status.info",
  "resolved": "ops.status.resolved"
}
}
